import React, { useState } from "react";
import ArbitratorCard from "./ArbitratorCard";
import Layout from "../../components/Layout/Layout";
import { useLanguage } from "../../context/LanguageContext";

// Итоговый список арбитров
const localArbitratorsData = [
  {
    id: 29,
    name: { ru: "Жаркынбеков Малик Кузарович" },
    experience: {
      ru: `Стаж по юридической специальности: 26 лет.
Судейский стаж: 21 год.

Место работы:
• 2024-н.в. - Член Палаты Юридических Консультантов - "Высшая Профессиональная Палата".
• 2022-2024 гг. - Судья Шымкентского городского суда.
• 2013-2022 гг. - Судья Актюбинского областного суда.
• 2009-2013 гг. - Председатель Специализированного Межрайонного Административного Суда г. Караганда.
• 2007-2009 гг. - Председатель Айтекебийского районного суда Актюбинской области.
• 2003-2007 гг. - Судья специализированного межрайонного экономического суда Актюбинской области.
• 2001-2003 гг. - Старший Специалист Государственно-правового Отдела Администрации Президента РК.
• 1998-2001 гг. - Помощник председателя, главный специалист суда города Астаны.
• 1997-1998 гг. - Юрист ТОО «Щит и меч».`,
    },
  },
  {
    id: 33,
    name: { ru: "Алишева Жанна Куандыковна" },
    experience: {
      ru: `Стаж по юридической специальности: 30 лет.
  Судейский стаж: 21 год.
  
  Место работы:
  • Лектор Академии правосудия при Высшем Судебном Совете Республики Казахстан.
  • 2021-2023 гг. - Судья судебной коллегии по административным делам Актюбинского областного суда.
  • 2010-2021 гг. - Судья судебной коллегии по гражданским делам Актюбинского областного суда.
  • 2002-2010 гг. - Судья специализированного межрайонного экономического суда Актюбинской области.
  • 2000-2002 гг. - Начальник отдела регистрации актов гражданского состояния Управления юстиции Актюбинской области.
  • 1998-2000 гг. - Ведущий консультант по нотариату Управления юстиции Актюбинской области.
  • 1997-1998 гг. - Главный специалист отдела регистрации юридических лиц Управления юстиции Актюбинской области.
  • 1994-1997 гг. - Юрисконсульт Коллективного предприятия «Жангак».
  
  Образование:
  • Казанский государственный университет им. В.И.Ульянова-Ленина, историк.
  • Казахская государственная юридическая академия, юриспруденция.
  
  Награды:
  • Юбилейная медаль «Қазақстан Конституциясына 20 жыл», Президент РК, 2015 год.
  • Медаль III степени «Міңсіз қызметі үшін», 2018 год.
  • Нагрудной знак I степени «Сот жүйесінің үздігі», 2021 год.
  • Почетный знак «Үш би» Союза Судей РК, 2022 год.
  • Юбилейная медаль «Қазақстан Республикасының сот жүйесіне 30 жыл», 2022 год.`,
    },
  },
  {
    id: 30,
    name: { ru: "Игиликов Назарбек" },
    experience: {
      ru: `Место работы:
• 2022-2025 гг. - Юридический консультант, Главная палата юридических консультантов Алматинской области.
• 2011-2022 гг. - Судья, Карасайский районный суд Алматинской области.
• 2007-2011 гг. - Судья, Костанайский областной суд.
• 2005-2007 гг. - Председатель, Аулиекольский районный суд Костанайской области.
• 2002-2005 гг. - Судья, Специализированный межрайонный экономический суд Актюбинской области.
• 2001 г. - Специалист, Верховный Суд РК.
• 2000 г. - Специалист, Суд города Астаны.`,
    },
  },
  {
    id: 32,
    name: { ru: "Байдилбеков Берик Асилбекович" },
    experience: {
      ru: `Общий стаж: более 27 лет.
  
  Место работы:
  • Май 2025 г. - по настоящее время - Адвокат Алматинской городской коллегии адвокатов.
  • 16.05.2024 г. - 05.05.2025 г. - Юрист-консультант, Гильдия юристов Казахстана.
  • Июнь 2016 г. - 2024 г. - Начальник юридического управления, ТОО «Энерджи Тараз».
  • 2014 г. - 31.05.2016 г. - Судья Карасайского районного суда Алматинской области.
  • 2012 г. - 2014 г. - Председатель Кербулакского районного суда № 2 Алматинской области.
  • 2004 г. - 2012 г. - Судья Балхашского районного суда Алматинской области.
  • 2000 г. - 2003 г. - Помощник прокурора Меркенского района Жамбылской области; прокурор НИАЦ Генеральной прокуратуры Республики Казахстан.
  • 1998 г. - 2000 г. - Помощник адвоката Алматинской областной коллегии адвокатов.
  
  Образование:
  • 1993-1998 гг. - Казахский государственный национальный университет им. аль-Фараби, Юридический факультет, специальность «Юриспруденция».`,
    },
  },
  // Остальные по убыванию (судьи с количеством дел)
  {
    id: 1,
    name: { ru: "Байменова Карлыгаш Гизатовна" },
    experience: {
      ru: `Общий стаж: 39 лет.
Количество рассмотренных дел: 312.

Место работы:
• 1975-1986 гг. - Октябрьский районный суд города Караганды, секретарь судебного заседания, судебный исполнитель.
• 1986-1997 гг. - Консультант Управления Юстиции, нотариус, консультант по судебной работе, начальник сектора кадров в Управлении Юстиции Карагандинской области.
• 1997-2002 гг. - Судья Карагандинского областного суда.
• 2002-2014 гг. - Судья суда г. Астана. Освобождена от должности в связи с уходом в отставку.`,
    },
  },
  {
    id: 3,
    name: { ru: "Искакова Жанар Кабидуллаевна" },
    experience: {
      ru: `Общий стаж: 30 год.
Количество рассмотренных дел: 224.

Место работы:
• 1996-2004 гг. - В органах прокуратуры РК.
• с 2005 г. - Состоит в коллегии адвокатов г.Астана.
• 2013-2015 гг. - Судья Третейского «Народного суда» г.Астана.
• с 2016 г. - Арбитраж г.Астана.`,
    },
  },
  {
    id: 24,
    name: { ru: "Беспалько Ирина Евгеньевна" },
    experience: {
      ru: `Общий стаж работы: 39 лет.
Стаж по юридической специальности: 32 года.

Место работы:
• С 2015 года - адвокат Актюбинской областной коллегии адвокатов.
• 1994-2015 гг. - руководитель юридической службы Актюбинского филиала АО «БТА Банк».
• 1987-1994 гг. - секретарь судебного заседания в судах города Актобе.

Образование:
• 1994 г. - Московская государственная юридическая академия, факультет юриспруденции.

Квалификация:
• Государственная лицензия на занятие адвокатской деятельностью. Прошла аттестацию в 2025 году.`,
    },
  },
  {
    id: 34,
    name: { ru: "Ерик Искандер" },
    experience: {
      ru: `Опыт работы:
• С 2013 года - руководитель ИП «Технологии и Сервис», работающего в сфере обслуживания медицинского и технологического оборудования.
• 2022-2024 гг. - директор ТОО «VITA.KZ».
• 2020-2022 гг. - директор ТОО «Atlas Medical Trade».
• 2012-2020 гг. - директор ТОО «РА».
• 2009-2012 гг. - директор ТОО «Дарихана-СК».
• 2000-2008 гг. - директор ТОО «Мед.Стом.Сервис».

Юридический опыт:
• Внештатное юридическое консультирование организаций в сфере фармацевтики и здравоохранения.

Образование:
• 2003-2007 гг. - филиал Карагандинского юридического института «Фемида» в Кокшетау, высшее образование.`,
    },
  },
  {
    id: 35,
    name: { ru: "Байгожина Алтынай" },
    experience: {
      ru: `Профессиональный опыт:
• С 2021 года - член Палаты профессиональных юридических консультантов, медиатор, арбитр; исполнительный директор ТОО «Freedom consult». Занимается юридическим сопровождением бизнеса, представительством в суде и досудебным урегулированием споров.
• 2016-2021 гг. - директор по развитию ТОО «KazDigitalSolutions».
• 2010-2016 гг. - работа в органах финансовой полиции и службе экономических расследований.
• 2008-2010 гг. - юрисконсульт ТОО «Жаснур».
• 2002-2008 гг. - работа в ДВД Акмолинской области.

Специализация:
• Договорное право, сопровождение бизнеса, медиация.

Образование:
• Высшее юридическое образование, 2003 г.
• Высшее филологическое образование, 1998 г.`,
    },
  },
  {
    id: 25,
    name: { ru: "Жумабеков Максат Кадырбекулы" },
    experience: {
      ru: `Общий стаж: 39 лет.
Количество рассмотренных дел: 20.

Место работы:
• 2000-2001 гг. - Секретарь судебного заседания суда г. Астаны.
• 2003-2006 гг. - Юрист, начальник юридического отдела в различных организациях.
• 2007-2011 гг. - Начальник юридического отдела, директор в РГКП УДП РК.`,
    },
  },
  {
    id: 23,
    name: { ru: "Ильясов Кайрат Аубакирович" },
    experience: {
      ru: `Общий стаж: 39 лет (судейский стаж - 9 лет).
Количество рассмотренных дел: 7.

Место работы:
• 2012-2021 гг. - Судья Специализированного межрайонного экономического суда ВКО, г. Усть-Каменогорск.`,
    },
  },
  {
    id: 26,
    name: {
      ru: "Исмагелов Ержан Маратович",
      kz: "Исмагелов Ержан Маратович",
      en: "Yerzhan Maratovich Ismagelov",
      zh: "叶尔然·马拉托维奇·伊斯马格洛夫",
    },
    experience: {
      ru: `Опыт работы: 12 лет 9 месяцев (по резюме).

Место работы:
• с июля 2025 г. - Управляющий директор Ellington Hills, г. Астана.
• Декабрь 2023 - май 2024 г. - Заместитель генерального директора ТОО «Antarium Group».
• Октябрь 2022 - июль 2023 г. - Управляющий директор ТОО «TUMAR GROUP».
• Апрель 2021 - октябрь 2022 г. - Директор по развитию компании «JETISU».
• Январь 2018 - август 2021 г. - Председатель ОЮЛ «Казахстанская Ассоциация профессионального управления жилым фондом».
• Апрель - ноябрь 2020 г. - Генеральный директор ТОО «BI Clients» (BI Group).
• Август 2019 - апрель 2020 г. - Директор по операционным вопросам ТОО «BI Clients» (BI Group).
• Май - август 2019 г. - Руководитель юридического управления ТОО «BI Clients» (BI Group).
• Июнь 2017 - май 2019 г. - Руководитель юридического отдела ТОО «Global Build» (BI Group).
• Февраль 2016 - май 2017 г. - Главный юрист ТОО «BI Service Consolidate» (BI Group).
• Декабрь 2014 - октябрь 2015 г. - Заместитель генерального директора по правовым вопросам ТОО «Строительная компания «Барит» (БАЗИС-А).
• Июнь - октябрь 2014 г. - Специалист отдела жизнеобеспечения аппарата акима г. Астаны.
• Февраль - май 2014 г. - Специалист юридического отдела ТОО «Астана-ЕРЦ».
• Май 2013 - февраль 2014 г. - Специалист юридического отдела ГУ «Управление жилищной инспекции города Астана».
• Май 2010 - апрель 2011 г. - Менеджер по маркетингу и рекламе ТОО «Центр микрохирургии глаза», г. Караганда.

Образование:
• 2010 г. - Карагандинский государственный университет имени Е. А. Букетова, юриспруденция, магистр.
• 2009 г. - Казахский гуманитарно-юридический университет, предпринимательское право, юриспруденция, магистр.

Повышение квалификации:
• 2020 г. - Swiss Business School (SBS), MBA; BI University, «Finance for professional».
• 2019 г. - BI University, «Управление финансами»; лекция Ицхака Адизеса «Управление жизненным циклом компании».
• 2018 г. - BI University, PreMBA и подготовка внутренних тренеров; Presidium Education, мастерство презентации; PRO HOUSE, управление жилой недвижимостью, г. Берлин.
• 2016 г. - International College of Business Trainers, управление групповой динамикой.

Специализация:
• Юридическое сопровождение, представительство в судах и государственных органах, жилищное законодательство.
• Стратегическое и операционное управление, развитие недвижимости, переговоры, автоматизация процессов.

Языки:
• Казахский - родной.
• Английский - A1, начальный.`,
      kz: `Жұмыс тәжірибесі: 12 жыл 9 ай (түйіндеме бойынша).

Жұмыс орындары:
• 2025 жылғы шілдеден бастап - Ellington Hills басқарушы директоры, Астана қ.
• 2023 жылғы желтоқсан - 2024 жылғы мамыр - «Antarium Group» ЖШС бас директорының орынбасары.
• 2022 жылғы қазан - 2023 жылғы шілде - «TUMAR GROUP» ЖШС басқарушы директоры.
• 2021 жылғы сәуір - 2022 жылғы қазан - «JETISU» компаниясының даму жөніндегі директоры.
• 2018 жылғы қаңтар - 2021 жылғы тамыз - «Қазақстанның тұрғын үй қорын кәсіби басқару қауымдастығы» ЗТБ төрағасы.
• 2020 жылғы сәуір - қараша - «BI Clients» ЖШС (BI Group) бас директоры.
• 2019 жылғы тамыз - 2020 жылғы сәуір - «BI Clients» ЖШС (BI Group) операциялық мәселелер жөніндегі директоры.
• 2019 жылғы мамыр - тамыз - «BI Clients» ЖШС (BI Group) заң басқармасының басшысы.
• 2017 жылғы маусым - 2019 жылғы мамыр - «Global Build» ЖШС (BI Group) заң бөлімінің басшысы.
• 2016 жылғы ақпан - 2017 жылғы мамыр - «BI Service Consolidate» ЖШС (BI Group) бас заңгері.
• 2014 жылғы желтоқсан - 2015 жылғы қазан - «Барит» құрылыс компаниясы» ЖШС (БАЗИС-А) бас директорының құқықтық мәселелер жөніндегі орынбасары.
• 2014 жылғы маусым - қазан - Астана қаласы әкімі аппаратының тіршілікті қамтамасыз ету бөлімінің маманы.
• 2014 жылғы ақпан - мамыр - «Астана-ЕРЦ» ЖШС заң бөлімінің маманы.
• 2013 жылғы мамыр - 2014 жылғы ақпан - «Астана қаласының тұрғын үй инспекциясы басқармасы» ММ заң бөлімінің маманы.
• 2010 жылғы мамыр - 2011 жылғы сәуір - «Көз микрохирургиясы орталығы» ЖШС маркетинг және жарнама менеджері, Қарағанды қ.

Білімі:
• 2010 ж. - Е. А. Бөкетов атындағы Қарағанды мемлекеттік университеті, құқықтану, магистр.
• 2009 ж. - Қазақ гуманитарлық заң университеті, кәсіпкерлік құқық, құқықтану, магистр.

Біліктілікті арттыру:
• 2020 ж. - Swiss Business School (SBS), MBA; BI University, «Finance for professional».
• 2019 ж. - BI University, «Қаржыны басқару»; Ицхак Адизестің «Компанияның өмірлік циклін басқару» дәрісі.
• 2018 ж. - BI University, PreMBA және ішкі тренерлерді даярлау; Presidium Education, таныстырылым шеберлігі; PRO HOUSE, тұрғын үй жылжымайтын мүлкін басқару, Берлин қ.
• 2016 ж. - International College of Business Trainers, топтық динамиканы басқару.

Мамандануы:
• Құқықтық сүйемелдеу, соттарда және мемлекеттік органдарда өкілдік ету, тұрғын үй заңнамасы.
• Стратегиялық және операциялық басқару, девелопмент, келіссөздер, процестерді автоматтандыру.

Тілдер:
• Қазақ тілі - ана тілі.
• Ағылшын тілі - A1, бастапқы деңгей.`,
      en: `Work experience: 12 years 9 months (as stated in the résumé).

Employment:
• Since July 2025 - Managing Director, Ellington Hills, Astana.
• December 2023 - May 2024 - Deputy General Director, Antarium Group LLP.
• October 2022 - July 2023 - Managing Director, TUMAR GROUP LLP.
• April 2021 - October 2022 - Development Director, JETISU.
• January 2018 - August 2021 - Chairman, Kazakhstan Association of Professional Housing Stock Management (association of legal entities).
• April - November 2020 - General Director, BI Clients LLP (BI Group).
• August 2019 - April 2020 - Director of Operations, BI Clients LLP (BI Group).
• May - August 2019 - Head of Legal Directorate, BI Clients LLP (BI Group).
• June 2017 - May 2019 - Head of Legal Department, Global Build LLP (BI Group).
• February 2016 - May 2017 - Chief Lawyer, BI Service Consolidate LLP (BI Group).
• December 2014 - October 2015 - Deputy General Director for Legal Affairs, Barit Construction Company LLP (BAZIS-A).
• June - October 2014 - Specialist, Municipal Services Department, Astana Akim's Office.
• February - May 2014 - Legal Department Specialist, Astana-ERC LLP.
• May 2013 - February 2014 - Legal Department Specialist, Astana Housing Inspection Directorate.
• May 2010 - April 2011 - Marketing and Advertising Manager, Eye Microsurgery Center LLP, Karaganda.

Education:
• 2010 - E. A. Buketov Karaganda State University, Law, master's degree.
• 2009 - Kazakh Humanities and Law University, Business Law, Law, master's degree.

Professional development:
• 2020 - Swiss Business School (SBS), MBA; BI University, Finance for Professional.
• 2019 - BI University, Financial Management; Ichak Adizes lecture on corporate lifecycle management.
• 2018 - BI University, PreMBA and internal trainer training; Presidium Education, presentation skills; PRO HOUSE, residential property management, Berlin.
• 2016 - International College of Business Trainers, group dynamics management.

Specialization:
• Legal support, representation before courts and government agencies, housing legislation.
• Strategic and operational management, property development, negotiations, process automation.

Languages:
• Kazakh - native.
• English - A1, beginner.`,
      zh: `工作经验：12年9个月（据简历）。

工作经历：
• 2025年7月至今 - Ellington Hills董事总经理，阿斯塔纳。
• 2023年12月—2024年5月 - Antarium Group有限责任公司副总经理。
• 2022年10月—2023年7月 - TUMAR GROUP有限责任公司董事总经理。
• 2021年4月—2022年10月 - JETISU公司发展总监。
• 2018年1月—2021年8月 - 哈萨克斯坦住房专业管理协会（法人联合会）主席。
• 2020年4月—11月 - BI Clients有限责任公司（BI Group）总经理。
• 2019年8月—2020年4月 - BI Clients有限责任公司（BI Group）运营总监。
• 2019年5月—8月 - BI Clients有限责任公司（BI Group）法律管理部门负责人。
• 2017年6月—2019年5月 - Global Build有限责任公司（BI Group）法务部负责人。
• 2016年2月—2017年5月 - BI Service Consolidate有限责任公司（BI Group）首席法律顾问。
• 2014年12月—2015年10月 - Barit建筑有限责任公司（BAZIS-A）法律事务副总经理。
• 2014年6月—10月 - 阿斯塔纳市长办公厅城市生活保障部门专员。
• 2014年2月—5月 - Astana-ERC有限责任公司法务部专员。
• 2013年5月—2014年2月 - 阿斯塔纳市住房监察局法务部专员。
• 2010年5月—2011年4月 - 眼科显微外科中心有限责任公司市场营销与广告经理，卡拉干达。

教育背景：
• 2010年 - 叶·阿·布克托夫卡拉干达国立大学，法学硕士。
• 2009年 - 哈萨克人文法律大学，商法、法学硕士。

进修培训：
• 2020年 - Swiss Business School（SBS），MBA；BI University，Finance for Professional。
• 2019年 - BI University，财务管理；伊查克·爱迪思企业生命周期管理讲座。
• 2018年 - BI University，PreMBA及内部培训师培训；Presidium Education，演讲展示技巧；PRO HOUSE，住宅房地产管理，柏林。
• 2016年 - International College of Business Trainers，群体动力管理。

专业领域：
• 法律支持、法院及政府机关代理、住房法律。
• 战略与运营管理、房地产开发、谈判、流程自动化。

语言：
• 哈萨克语 - 母语。
• 英语 - A1，初级。`,
    },
  },
  {
    id: 4,
    name: { ru: "Жумагельдиев Талгат Каирлыевич" },
    experience: {
      ru: `Общий стаж: 39 лет.
Количество рассмотренных дел: 6.

Место работы:
• 1996-2004 гг. - В органах прокуратуры Карагандинской области.
• 2004-2015 гг. - Руководящие должности юридических отделов в АО и ТОО.
• с 2015 г. - Директор ТОО «Женic капитал».`,
    },
  },
  {
    id: 20,
    name: { ru: "Рысбаев Алтынбек Калдыбекович" },
    experience: {
      ru: `Стаж по юридической специальности: более 21 года.

Текущее место работы:
• с апреля 2026 г. - Менеджер по проектам (советник генерального директора), ТОО «НИПИ Астанагенплан», г. Астана.

Образование:
• 2005 г. - Кокшетауский университет, специальность «Юриспруденция».

Языки:
• Казахский.
• Русский.
• Английский.

Опыт работы:
• 02.02.2005 - 03.08.2005 - Юрист, ТОО «Бай-Тан», г. Астана.
• 08.08.2005 - 27.10.2006 - Юрист, ТОО «Агентство «Байтерек-Астана», г. Астана.
• 05.11.2006 - 07.05.2008 - Начальник юридического отдела, Агентство «Асар», г. Астана.
• 10.05.2008 - 30.04.2009 - Начальник юридического отдела, ТОО «Компания Бай-Тан», г. Астана.
• 04.05.2009 - 15.07.2009 - Специалист посткредитного обслуживания, представительство АО «Ипотечная организация «БТА Ипотека» №1 в г. Астана.
• 15.07.2009 - 01.07.2011 - Главный специалист отдела правового сопровождения, представительство АО «Ипотечная организация «БТА Ипотека» №1 в г. Астана.
• 01.07.2011 - 01.12.2011 - Начальник отдела правового сопровождения, представительство АО «Ипотечная организация «БТА Ипотека» №1 в г. Астана.
• 03.10.2013 - 18.09.2017 - Главный специалист по оказанию правовой помощи, ГУ «Управление архитектуры и градостроительства г. Астана».
• 01.10.2019 - 25.05.2020 - Главный специалист юридического отдела, ТОО «Әскери құрылыс Астана», г. Астана.
• 20.05.2020 - 01.09.2022 - Директор, ТОО «Nur Invest Project», г. Астана.
• 01.09.2022 - 14.04.2023 - Руководитель отдела мониторинга, ТОО «НИПИ Астанагенплан», г. Астана.
• 14.04.2023 - 11.10.2023 - Координатор по цифровизации, ТОО «НИПИ Астанагенплан», г. Астана.
• 11.10.2023 - 30.04.2024 - Комплаенс-офицер, ТОО «НИПИ Астанагенплан», г. Астана.
• 02.05.2024 - 10.06.2025 - Заместитель генерального директора, ТОО «НИПИ Астанагенплан», г. Астана.
• 11.06.2025 - 31.03.2026 - Главный специалист отдела научных исследований и нормативно-технических работ, ТОО «НИПИ Астанагенплан», г. Астана.
• 01.04.2026 - по настоящее время - Менеджер по проектам, ТОО «НИПИ Астанагенплан», г. Астана.

Дополнительно:
• Дата рождения: 13 декабря 1979 года.
• Место рождения: пос. Шаған, Кызылординская область.
• Национальность: казах.
• Ученой степени, ученого звания и государственных наград не имеет.`,
    },
  },
  {
    id: 8,
    name: { ru: "Касымова Бахыт Жангельдиновна" },
    experience: {
      ru: `Стаж по юридической специальности: 25 лет.

Место работы:
• Частная юридическая практика, представление интересов юридических и физических лиц по гражданским, уголовным, корпоративным, семейным, жилищным, земельным и иным категориям дел.
• 2004-2008 гг. - Начальник юридической службы, ТОО «Гражданпромстрой».
• 2003-2004 гг. - Главный специалист отдела правового и конкурсного обеспечения, ГУ «Департамент жилья г. Астана».
• 2000-2003 гг. - Главный специалист, Военный суд Акмолинского гарнизона, г. Астана.
• 1998-2000 гг. - Секретарь судебного заседания, главный специалист суда, Алматинский районный суд г. Астаны.
• 1995-1997 гг. - Секретарь судебного заседания, Нуринский народный суд Карагандинской области, пгт. Киевка.

Образование:
• 2004-2007 гг. - Частный университет Карагандинского института актуального образования «Болашак», бакалавр юриспруденции.
• 2002-2004 гг. - Акмолинский финансово-экономический колледж, специальность «Юрист».
• 1992-1994 гг. - Акмолинский кооперативный техникум, специальность «Бухгалтер».

Документы и квалификация:
• Лицензия частного судебного исполнителя.
• Сертификат конкурсного банкротного управляющего.
• Успешно пройдена стажировка для сдачи квалификационного экзамена на получение адвокатской лицензии.
• Сертификаты повышения квалификации, участие в юридических семинарах, лекциях, конференциях и круглых столах.

Ключевые навыки:
• Юридическое сопровождение бизнеса.
• Досудебное урегулирование споров и управление переговорами.
• Аналитика, правовая экспертиза и стратегическое планирование.
• Быстрый анализ перспективности спора и выстраивание процессуальной позиции.

Языки:
• Казахский - в совершенстве.
• Русский - в совершенстве.`,
    },
  },
  {
    id: 28,
    name: { ru: "Мадьярова Жулдыз Нуркашевна" },
    experience: {
      ru: `Общий стаж: 30 лет.
Количество рассмотренных дел: 3.

Место работы:
• 1988-1991 гг. – Старший консультант управления юстиции Атырауской области.
• 1991-1995 гг. – Арбитр, Судья Арбитражного суда Атырауской области.
• 1996-2018 гг. – Председатель судебной коллегии, Судья Атырауского областного суда.
• с 2018 г. – Судья в почетной отставке.`,
    },
  },
  {
    id: 27,
    name: { ru: "Касенов Алихан Ермекович" },
    experience: {
      ru: `Общий стаж: 29 лет.

Место работы:
• 1987–1994 гг. - Служба в ОВД, следственный отдел, УВД Карагандинской области.
• 1984–1999 гг. - Судья Шахтинского районного суда.
• 1999–2010 гг. - Судья Карагандинского областного суда.
• 2010–2024 гг. - Судья суда города Астаны. В апреле 2024 года ушел в отставку.`,
    },
  },
  {
    id: 31,
    name: { ru: "Туякбаев Арман Медальбаевич" },
    experience: {
      ru: `Общий стаж: более 20 лет.
Место работы:
• с февраля 2025 г. – Руководитель Отдела внутренней безопасности, РГП «Енбек», г. Астана.
• июль 2024 – февраль 2025 гг. – Главный эксперт юридического управления, РГП «Енбек».
• май 2022 – июль 2024 гг. – Адвокат, Коллегия адвокатов г. Астана.
• февраль 2020 – апрель 2022 гг. – Специалист службы безопасности, ТОО «КазТранзитСервис».
• февраль 2018 – февраль 2020 гг. – Юрист, ТОО «Козыкош».
• ноябрь 2017 – февраль 2018 гг. – Заместитель директора, ТОО «Дилайн Групп».
• май 2016 – январь 2020 гг. – Директор, ТОО «Центр правовой помощи и защиты».
• 2015 – 2016 гг. – Старший следователь / эксперт-офицер, Департамент государственных доходов СКО.
• 2012 – 2014 гг. – Главный специалист Управления внутренней безопасности, Комитет таможенного контроля МФ РК.
• 2008 – 2012 гг. – Главный специалист по организации оперативной работы, Департамент таможенного контроля СКО.
• 2000 – 2008 гг. – Оперуполномоченный, старший криминалист, участковый инспектор, УВД г. Петропавловск, Есильский РОВД СКО.

Образование:
• 2007 г. – Академия МВД РК, магистр правоохранительной деятельности.
• 2005 г. – Академия МВД РК, юрист.
• 2000 г. – Шымкентский юридический колледж МВД РК.

Дополнительно:
• Свободно владеет казахским и русским языками, английский — со словарем.
• Специализация: внутренняя безопасность, правовая и аналитическая работа, антикоррупционная деятельность.`,
    },
  },
  {
    id: 5,
    name: {
      ru: "Танатов Бауыржан",
      kz: "Танатов Бауыржан",
      en: "Bauyrzhan Tanatov",
      zh: "包尔然·塔纳托夫",
    },
    experience: {
      ru: `Место работы:
• с ноября 2018 г. - Начальник юридического отдела ТОО «GorSvetGroup», г. Астана.
• Ноябрь 2016 - ноябрь 2018 г. - Начальник юридического отдела ТОО «Rostra Group», г. Астана.
• Июль 2015 - октябрь 2016 г. - Директор правового обеспечения и закупок АО «Специальная экономическая зона «НИНТ», г. Атырау.
• Ноябрь 2011 - июнь 2015 г. - Менеджер по закупкам-юрист ТОО «Казатомсервис», г. Астана.
• Август 2008 - ноябрь 2011 г. - Инженер производственно-технического отдела АО «Казнефтегазмонтаж - Тараз», г. Тараз.

Образование:
• 2009-2011 гг. - Международный Таразский инновационный институт имени Шерхана Муртазы, юриспруденция, бакалавр.
• 2004-2008 гг. - Таразский государственный университет имени М. Х. Дулати, разработка нефтегазовых месторождений, инженер нефтегазовой отрасли.
• 2002-2004 гг. - Военный институт сухопутных войск, г. Алматы, специальность «Воздушно-десантные войска и войсковая разведка».

Квалификация:
• с ноября 2021 г. - Член Северо-Казахстанской палаты юридических консультантов «ZANGER», №ЮК-Ф15/165/01-05-21.

Специализация:
• Правовое сопровождение деятельности компаний, контрактов и договоров.
• Представительство в судах и государственных органах, переговоры, управление правовыми рисками.
• Правовое обеспечение закупок, организация работы юридического отдела и наставничество.

Языки:
• Казахский - родной.
• Русский - свободно.
• Английский - со словарем.`,
      kz: `Жұмыс орындары:
• 2018 жылғы қарашадан бастап - «GorSvetGroup» ЖШС заң бөлімінің басшысы, Астана қ.
• 2016 жылғы қараша - 2018 жылғы қараша - «Rostra Group» ЖШС заң бөлімінің басшысы, Астана қ.
• 2015 жылғы шілде - 2016 жылғы қазан - «НИНТ» арнайы экономикалық аймағы» АҚ құқықтық қамтамасыз ету және сатып алу жөніндегі директоры, Атырау қ.
• 2011 жылғы қараша - 2015 жылғы маусым - «Казатомсервис» ЖШС сатып алу менеджері-заңгері, Астана қ.
• 2008 жылғы тамыз - 2011 жылғы қараша - «Казнефтегазмонтаж - Тараз» АҚ өндірістік-техникалық бөлімінің инженері, Тараз қ.

Білімі:
• 2009-2011 жж. - Шерхан Мұртаза атындағы Халықаралық Тараз инновациялық институты, құқықтану, бакалавр.
• 2004-2008 жж. - М. Х. Дулати атындағы Тараз мемлекеттік университеті, мұнай-газ кен орындарын игеру, мұнай-газ саласының инженері.
• 2002-2004 жж. - Құрлық әскерлерінің әскери институты, Алматы қ., «Әуе-десант әскерлері және әскери барлау» мамандығы.

Біліктілігі:
• 2021 жылғы қарашадан бастап - Солтүстік Қазақстан «ZANGER» заң консультанттары палатасының мүшесі, №ЮК-Ф15/165/01-05-21.

Мамандануы:
• Компаниялар қызметін, келісімшарттар мен шарттарды құқықтық сүйемелдеу.
• Соттарда және мемлекеттік органдарда өкілдік ету, келіссөздер, құқықтық тәуекелдерді басқару.
• Сатып алуды құқықтық қамтамасыз ету, заң бөлімінің жұмысын ұйымдастыру және тәлімгерлік.

Тілдер:
• Қазақ тілі - ана тілі.
• Орыс тілі - еркін.
• Ағылшын тілі - сөздікпен.`,
      en: `Employment:
• Since November 2018 - Head of Legal Department, GorSvetGroup LLP, Astana.
• November 2016 - November 2018 - Head of Legal Department, Rostra Group LLP, Astana.
• July 2015 - October 2016 - Director of Legal Support and Procurement, NINT Special Economic Zone JSC, Atyrau.
• November 2011 - June 2015 - Procurement Manager / Lawyer, Kazatomservice LLP, Astana.
• August 2008 - November 2011 - Production and Technical Department Engineer, Kazneftegazmontazh - Taraz JSC, Taraz.

Education:
• 2009-2011 - Sherkhan Murtaza International Taraz Innovation Institute, Law, bachelor's degree.
• 2004-2008 - M. Kh. Dulaty Taraz State University, Oil and Gas Field Development, oil and gas engineer qualification.
• 2002-2004 - Military Institute of the Ground Forces, Almaty, Airborne Forces and Military Intelligence.

Qualification:
• Since November 2021 - Member of the North Kazakhstan Chamber of Legal Consultants ZANGER, No. ЮК-Ф15/165/01-05-21.

Specialization:
• Legal support for corporate activities, contracts and agreements.
• Representation before courts and government agencies, negotiations, legal risk management.
• Legal support for procurement, legal department management and mentoring.

Languages:
• Kazakh - native.
• Russian - fluent.
• English - with a dictionary.`,
      zh: `工作经历：
• 2018年11月至今 - GorSvetGroup有限责任公司法务部负责人，阿斯塔纳。
• 2016年11月—2018年11月 - Rostra Group有限责任公司法务部负责人，阿斯塔纳。
• 2015年7月—2016年10月 - NINT经济特区股份公司法律支持与采购总监，阿特劳。
• 2011年11月—2015年6月 - Kazatomservice有限责任公司采购经理兼法律顾问，阿斯塔纳。
• 2008年8月—2011年11月 - Kazneftegazmontazh - Taraz股份公司生产技术部工程师，塔拉兹。

教育背景：
• 2009—2011年 - 谢尔汗·穆尔塔扎国际塔拉兹创新学院，法学学士。
• 2004—2008年 - 穆·赫·杜拉提塔拉兹国立大学，油气田开发专业，油气工程师资格。
• 2002—2004年 - 陆军军事学院，阿拉木图，空降兵与军事侦察专业。

专业资格：
• 自2021年11月起 - 北哈萨克斯坦ZANGER法律顾问协会会员，编号ЮК-Ф15/165/01-05-21。

专业领域：
• 企业经营活动、合同与协议的法律支持。
• 法院及政府机关代理、谈判、法律风险管理。
• 采购法律支持、法务部管理与员工指导。

语言：
• 哈萨克语 - 母语。
• 俄语 - 流利。
• 英语 - 借助词典。`,
    },
  },
  {
    id: 6,
    name: { ru: "Баймедетов Марат Аймырзаевич" },
    experience: {
      ru: `Общий стаж: 18 лет.

Место работы:
• 2000-2010 гг. - Специалист Шуской транспортной прокуратуры.
• 2010 г. - Старший специалист Генеральной прокуратуры.
• 2012-2015 гг. - Советник Министра по инвестициям.
• В настоящее время - директор ТОО "Bill Corporation".`,
    },
  },
];

const foreignArbitratorsData = [
  {
    id: 101,
    name: { ru: "У Чэнфан" },
    experience: {
      ru: `Страна: Китай.
Стаж адвокатской практики: более 10 лет.

Место работы:
• Зарегистрированный арбитр Фучжоуской арбитражной комиссии.
• Декан Финансового арбитражного института при Фучжоуской арбитражной комиссии.
• 2008 г. - настоящее время - Управляющий партнер и директор Пекинской юридической фирмы «Цзуньпин».
• 2005-2008 гг. - Юридический консультант Пекинской строительной группы «Ваньсин».
• 2001-2003 гг. - Инспекционная группа Управления по качеству и техническому надзору провинции Цзянси.

Образование:
• 1997-2001 гг. - Цзянсийский институт образования, специальность «Китайский язык и литература», бакалавр.

Специализация:
• Гражданские и коммерческие споры.
• Уголовные дела.
• Обеспечение исков и исполнительное производство.
• Корпоративные споры и внесудебное юридическое сопровождение.

Квалификация:
• Действующее удостоверение адвоката.
• Опыт ведения более ста судебных дел различных категорий.`,
    },
  },
  {
    id: 102,
    name: { ru: "Чэнь Сюймэй" },
    experience: {
      ru: `Страна: Китай.
Стаж адвокатской практики: 11 лет.

Место работы:
• Зарегистрированный арбитр Фучжоуской арбитражной комиссии.
• Арбитр Финансового арбитражного института Фучжоу, председатель Комитета по рынкам капитала.
• Председатель Комитета по исследованию финансового права Четвертой коллегии адвокатов района Дасин г. Пекина.
• Заместитель председателя Комитета по исследованию корпоративного права Четвертой коллегии адвокатов района Дасин г. Пекина.
• Член Дисциплинарного комитета Четвертой коллегии адвокатов района Дасин г. Пекина.

Образование:
• Шаньдунский университет финансов и экономики, бакалавр в области управления.
• Китайский университет политических наук и права, заочная магистратура, специализация «Гражданское право».

Специализация:
• Корпоративное управление, комплаенс и контроль рисков.
• Рынки капитала, акционерная стратегия, трансграничные инвестиционные структуры.
• Частные фонды, специальные механизмы листинга, коммерческие споры.
• Предупреждение коммерческих споров через досудебное арбитражное посредничество.

Квалификация:
• Квалификация в сфере фондовой деятельности.
• Квалификация в сфере ценных бумаг.
• Сертификат CET-6.
• Второй уровень компьютерной грамотности.`,
    },
  },
  {
    id: 103,
    name: { ru: "Лю Диси" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• 2024 г. - настоящее время - Соучредитель и заместитель директора Пекинской юридической фирмы «Бату».
• с 2014 г. - Пекинская юридическая фирма «Бошэнь», управление юридической фирмой и административные вопросы.
• Член Комитета по семейному и наследственному праву Ассоциации юристов района Дасин г. Пекина.
• Член Комитета по корпоративному праву Ассоциации юристов района Дасин г. Пекина.

Образование:
• Пекинский университет материальных ресурсов, специальность «Финансы (ценные бумаги, фьючерсы)».
• Китайский университет политологии и права, заочная магистратура.

Специализация:
• Корпоративное право, слияния и поглощения, акционерные споры.
• Договорные споры, семейные дела, наследование, возмещение ущерба.
• Уголовные дела: взяточничество, мошенничество, незаконное привлечение депозитов, экономические и иные преступления.
• Выход компаний на биржу, акционерное проектирование, инвестиции и финансирование, трудовое управление.

Квалификация:
• Многолетний опыт управления юридической фирмой.
• Опыт комплаенс-проверок и управления корпоративными рисками.`,
    },
  },
  {
    id: 104,
    name: { ru: "Сунь Хайбо" },
    experience: {
      ru: `Страна: Китай.
Стаж юридической практики: 16 лет.

Место работы:
• с июня 2025 г. - Директор Пекинской юридической фирмы «Вэйли».
• 2020-2025 гг. - Директор Пекинской юридической фирмы «Голэй».
• 2012-2020 гг. - Штатный адвокат Пекинской юридической фирмы «Дамин».
• Зарегистрированный арбитр Арбитражной комиссии Фучжоу.
• Вице-президент Финансового арбитражного суда Арбитражной комиссии Фучжоу.
• Арбитр Международного арбитражного суда нового района Ганьчжоу и Арбитражной комиссии Юлинь.

Образование:
• 2010-2016 гг. - Пекинский университет, бакалавр права.
• 2013-2015 гг. - Северо-Китайский университет промышленности, магистр права.

Специализация:
• Внутренняя торговля и строительная отрасль.
• Дебиторская задолженность предприятий и принудительное исполнение.
• Коммерческий арбитраж, медиация, гражданские и коммерческие споры.
• Договоры поставки, кредитные соглашения, медицинские и фармацевтические договоры, корпоративный комплаенс.

Квалификация:
• Единый государственный экзамен на юридическую квалификацию сдан в 2010 году.
• Свидетельство адвоката получено в 2015 году.
• Сертифицированный специалист по корпоративному комплаенсу.
• Базовые навыки чтения и письменного перевода на английском языке.`,
    },
  },
  {
    id: 105,
    name: { ru: "Цзэн Шаньэнь" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• 2014 г. - настоящее время - Юридическая фирма «Гуандун Наньфан Фужуйдэ», штатный адвокат.
• 2018 г. - настоящее время - Арбитр Бэйхайской международной арбитражной палаты при Арбитражной комиссии Бэйхая.

Образование:
• 2004-2010 гг. - Центральный университет радио и телевидения, бакалавр, специальность «Юриспруденция».
• 2001-2004 гг. - Гуанчжоуский университет радио и телевидения, юриспруденция.
• 1995-1999 гг. - Шанхайская портовая школа, специальность «Финансовый учет на водном транспорте».

Специализация:
• Юридические консультационные услуги.
• Судебная практика и арбитраж.

Контакты:
• Телефон: +86 13609094569.
• Эл. почта: 88318@163.com.`,
    },
  },
  {
    id: 106,
    name: { ru: "Ху Хунцзюнь" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• Январь 2024 г. - настоящее время - Председатель Международной арбитражной палаты по экономической и торговой деятельности при Арбитражной комиссии Фучжоу.
• Октябрь 2024 г. - настоящее время - Арбитр Арбитражного центра Всемирного торгового центра в Макао.
• 2022 г. - настоящее время - Арбитр Наньпинской международной арбитражной палаты.
• 2018 г. - настоящее время - Арбитр Бэйхайской международной арбитражной палаты.
• 2016 г. - настоящее время - Арбитр Арбитражной комиссии Чжаньцзян.
• 1992-2004 гг. - Помощник судьи, судебный исполнитель в Народном суде средней инстанции города Гуанчжоу.

Образование:
• 2001-2003 гг. - Китайский университет политических наук и права, экономическое право.
• 2002-2005 гг. - Нанкинский университет науки и технологий, управление персоналом.
• 2003-2006 гг. - Пекинский университет, юриспруденция.

Специализация:
• Арбитраж, экономические и торговые споры.
• Судебное исполнение и разрешение коммерческих конфликтов.

Контакты:
• Телефон: 13802752536, 020-83342001.
• Эл. почта: 941864185@qq.com.`,
    },
  },
  {
    id: 107,
    name: { ru: "Сунь Цянь" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• Практикующий адвокат Пекинской юридической фирмы «Хуаньин».
• Имеет многолетний опыт работы в финансовой сфере.

Образование:
• Центральный университет финансов и экономики.

Специализация:
• Гражданское и уголовное право.
• Корпоративные споры, акционерный капитал, крупные коммерческие контракты.
• Защита компаний и топ-менеджеров по делам об экономических и должностных преступлениях.
• Слияния и поглощения, инвестиционные проекты, взыскание задолженности и строительный подряд.

Профессиональный опыт:
• Участвовал в крупных уголовных делах по незаконному привлечению средств и незаконной предпринимательской деятельности.
• Сопровождал гражданские и коммерческие дела с суммами споров от нескольких миллионов до десятков миллиардов юаней.
• Использует гибкие методы ведения дел и ориентируется на практические решения для сторон спора.`,
    },
  },
  {
    id: 108,
    name: { ru: "Сун Цзиньюй" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• 2015 г. - настоящее время - Старший партнер и руководитель отдела по работе с иностранными клиентами Пекинской юридической фирмы «Цзинпин».
• 2012-2015 гг. - Юрист-партнер Пекинской юридической фирмы «Шэнъюнь».
• 2008-2011 гг. - Юрист Пекинской юридической фирмы «Тяньжуй».

Образование:
• 2000-2004 гг. - Линьиский педагогический институт, английский язык.
• 2004-2007 гг. - Университет международного бизнеса и экономики, магистр права.
• 2008-2013 гг. - Китайская академия общественных наук, магистр экономики, финансы.
• 2020-2022 гг. - Народный университет Китая, EMBA.

Специализация:
• Юридическое сопровождение китайских и зарубежных компаний.
• Административные споры, гражданские и коммерческие дела, уголовные дела.
• Иностранные правовые услуги, взаимодействие с торгово-промышленными ассоциациями и зарубежными юридическими фирмами.
• Управление юридической фирмой и стратегическое развитие.

Квалификация:
• Сертификат адвоката.
• Английский язык TEM-8.
• Сертификаты специалиста по корпоративному комплаенсу, структуре акционерного капитала и трудовым отношениям.`,
    },
  },
  {
    id: 109,
    name: { ru: "Лу Бинь" },
    experience: {
      ru: `Страна: Китай.
Стаж в исполнительном производстве и банкротстве: более 10 лет.

Место работы:
• 2018 г. - настоящее время - Основатель и директор Пекинской юридической фирмы «Цзяхуань».
• 2014-2018 гг. - Пекинская юридическая фирма «Сунтао».
• 2010-2014 гг. - Пекинская юридическая фирма «Цинтянь».

Специализация:
• Оздоровление и взыскание проблемных активов.
• Исполнение судебных решений по прекращенным делам.
• Банкротство и взыскание задолженности.
• Трансграничное принудительное исполнение.

Общественные и отраслевые должности:
• Член Пекинской коллегии адвокатов.
• Наблюдатель Коллегии адвокатов района Шуньи.
• Наблюдатель Пекинской коллегии адвокатов.

Квалификация:
• Квалификация юриста класса A.
• Языки: русский, китайский.`,
    },
  },
  {
    id: 110,
    name: { ru: "Ду Лиминь" },
    experience: {
      ru: `Страна: Китай.
Общий стаж в юридической сфере: более 17 лет.
Стаж адвокатской практики: более 6 лет.

Место работы:
• 2020 г. - настоящее время - Старший партнер и руководитель команды юридической фирмы «Пекин Цзиньхэн» (Гуанчжоу).
• 2017-2020 гг. - Юридическая фирма «Хунань Куанчжэнь», стажер-адвокат, затем практикующий адвокат.
• 2009-2017 гг. - Отдел комплаенс-рисков в банковской системе, Синьцзян.

Образование:
• 2001-2005 гг. - Синьцзянский университет финансов и экономики, юриспруденция, бакалавр права.
• 2006-2009 гг. - Синьцзянский университет, теория права, магистратура.

Специализация:
• Строительное право и коммерческие споры.
• Договоры строительного подряда, задолженность по оплате работ, качество строительства, нарушение сроков.
• Исполнительное производство и взыскание средств.
• Медиация и урегулирование гражданских и коммерческих конфликтов.

Квалификация:
• Сертификат о юридической квалификации класса A.
• Адвокатское удостоверение.
• Сертификат CET-6 по английскому языку.
• Сертифицированный международный финансовый планировщик (CIFP).`,
    },
  },
  {
    id: 111,
    name: { ru: "Чжоу Вэйцзя" },
    experience: {
      ru: `Страна: Китай.
Судебный стаж: 16 лет.

Место работы:
• 2022 г. - настоящее время - Юрист-партнер Тяньцзиньской юридической фирмы «Дунфан».
• 2006-2022 гг. - Судебная система Синьцзянского производственно-строительного корпуса: секретарь суда, судья, председатель суда, председатель гражданской коллегии.

Образование:
• 2014-2015 гг. - Даляньский морской университет, магистр права.
• 2002-2006 гг. - Синьцзянский педагогический университет, юриспруденция, бакалавр права.

Специализация:
• Гражданские и коммерческие экономические споры.
• Юридическое консультирование предприятий.
• Страховые споры, корпоративный комплаенс и управление рисками.
• Международный арбитраж и трансграничные коммерческие споры.

Квалификация:
• Свидетельство о допуске к адвокатской практике КНР.
• Национальный сертификат о юридической квалификации.
• Русский язык на уровне, достаточном для юридического общения и работы с документами по странам Центральной Азии и России.`,
    },
  },
  {
    id: 112,
    name: { ru: "Ли Янь" },
    experience: {
      ru: `Страна: Китай.
Общий стаж в юридической сфере: 10 лет.
Стаж адвокатской практики: более 6 лет.

Место работы:
• 2022 г. - настоящее время - Старший партнер, руководитель юридической фирмы и команды в юридической фирме «Пекин Цзиньхэн».
• 2019-2022 гг. - Практикующий адвокат Пекинской юридической фирмы «Цэлюэ».
• 2017-2019 гг. - Пекинская юридическая фирма «Ланьпэн».
• 2016-2017 гг. - Пекинская юридическая фирма «Цзинши».

Образование:
• 2010-2014 гг. - Шэньянский педагогический университет, английский язык.
• 2015-2018 гг. - Университет международных отношений, юриспруденция, магистратура.

Специализация:
• Споры по договорам строительного подряда.
• Коммерческие договорные споры, взыскание задолженности, арендные споры.
• Коммерческий арбитраж и принудительное исполнение.
• Инфраструктурные и строительные проекты, медиация и арбитражный процесс.

Квалификация:
• Сертификат о юридической квалификации класса A.
• Адвокатское удостоверение.
• Сертификат TEM-8 по английскому языку.
• Сертификат владения путунхуа уровня 2-А.`,
    },
  },
  {
    id: 113,
    name: { ru: "Ян Лин" },
    experience: {
      ru: `Страна: Китай.
Общий стаж в юридической сфере: 16 лет.
Стаж адвокатской практики: более 5 лет.

Место работы:
• 2020 г. - настоящее время - Основатель-партнер юридической фирмы «Пекин Цзиньхэн», руководитель филиала «Пекин Цзиньхэн» (Тяньцзинь).
• 2017-2020 гг. - Юридическая фирма «Хунань Куанчжэнь» (Урумчи): адвокат по работе с клиентами, руководитель судебного направления, руководитель отдела по работе с клиентами.
• 2010-2017 гг. - Суд Цитуаньского заимочного района Синьцзянского производственно-строительного корпуса: секретарь суда, помощник судьи.

Образование:
• 2006-2010 гг. - Синьцзянский университет, юриспруденция, бакалавр права.

Специализация:
• Строительные споры, договоры строительного подряда, тендеры и субподряд.
• Договорные споры, купля-продажа, аренда, займы, поручительство и партнерство.
• Взыскание задолженности, исполнительное производство и коммерческий арбитраж.
• Медиация, арбитражные слушания и последующее исполнение решений.

Профессиональный опыт:
• За последние годы команда ежегодно рассматривает более 200 коммерческих дел.
• Более 50 дел ежегодно проходят в арбитражных комиссиях Пекина, Тяньцзиня, Шанхая, Уханя и других городов.
• Общая сумма средств, взысканных в пользу клиентов, превышает 2 млрд юаней.

Квалификация:
• Сертификат о юридической квалификации класса A.
• Адвокатское удостоверение.`,
    },
  },
  {
    id: 114,
    name: { ru: "Чжан Чао" },
    experience: {
      ru: `Страна: Китай.
Судебный стаж: 5 лет.
Опыт работы в судебных и следственных органах: более 10 лет.

Место работы:
• 2020 г. - настоящее время - Руководитель, управляющий партнер юридической фирмы «Пекин Цзиньхэн», направление строительного права и коммерческих споров.
• 2014-2020 гг. - Юридическая фирма «Хунань Куанчжэнь»: стажер-адвокат, практикующий адвокат, партнер.
• 2013-2020 гг. - Народная прокуратура Синьцзян-Уйгурского автономного района, прокурор.
• 2008-2013 гг. - Судья Народного суда района Шайибагэ, г. Урумчи.

Образование:
• 2001-2005 гг. - Северо-Западный университет политических наук и права, юриспруденция, бакалавриат.
• 2005-2008 гг. - Синьцзянский университет, юриспруденция, магистратура.

Специализация:
• Гражданское и коммерческое право, договорное право, вещное право, обеспечительное право.
• Корпоративное право, банкротство, строительный подряд.
• Расследование и защита по делам о должностных преступлениях.
• Коммерческий арбитраж и принудительное исполнение судебных решений.

Профессиональный опыт:
• За время работы в суде рассмотрел более 1800 гражданских и коммерческих дел.
• Участвовал в расследовании крупных и особо важных коррупционных дел.
• Представлял интересы доверителей по строительным и коммерческим арбитражным делам.

Квалификация:
• Сертификат о юридической квалификации класса A.
• Действующий статус практикующего адвоката.`,
    },
  },
  {
    id: 115,
    name: { ru: "Инь Сянъян" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• 2020 г. - настоящее время - Пекинская юридическая фирма «Цзуньпин».
• 2014-2020 гг. - Пекинская юридическая фирма «Ханьда».
• 2008-2014 гг. - Работа в суде.

Образование:
• Китайский университет политических наук и права, магистр.

Специализация:
• Гражданские и коммерческие судебные споры и арбитраж.
• Корпоративные вопросы и договорные споры.
• Частные займы, семейные и наследственные дела.
• Возмещение вреда и трудовые споры.

Квалификация:
• Сертификат CET-6 по английскому языку.
• Глубокое знание коммерческого законодательства.
• Автор публикаций в изданиях «Пекинские судьи» и «Пекинское правосудие».
• Работа о принятии долга получила вторую общенациональную премию на 26-м Всекитайском академическом симпозиуме судов.`,
    },
  },
  {
    id: 116,
    name: { ru: "Дин Чуньянь" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• Июнь 2025 г. - настоящее время - Старший партнер юридической фирмы SGLA (Пекин).
• 2021-2025 гг. - Директор коммерческого департамента Пекинской юридической фирмы «Хэчжидунь».
• 2019-2021 гг. - Постдокторант Китайской академии сельскохозяйственных наук.
• 2018-2019 гг. - Преподаватель юридического факультета Гуандунского университета финансов.
• 2017-2018 гг. - Инвестиционный директор, Country Garden Holdings.

Образование:
• Уханьский университет, доктор права.
• Университет Маккуори, доктор философии в области бухгалтерского учета и корпоративного менеджмента.

Специализация:
• Международный комплаенс.
• Коммерческие судебные споры и арбитраж.
• Инвестиционные поглощения и слияния.
• Юридическое сопровождение международной деятельности китайских предприятий.

Квалификация:
• Входит в кадровый резерв адвокатов по международным делам Пекинской коллегии адвокатов.
• Член Центрального юридического комитета Общества 93.
• Член юридического комитета Пекинского объединения выпускников Европы и Америки.
• Член национальных комитетов SGLA по корпоративному комплаенсу и строительству.
• Автор и соавтор научных и практических юридических изданий.`,
    },
  },
  {
    id: 117,
    name: { ru: "Сун Сяоин" },
    experience: {
      ru: `Страна: Китай.
Стаж юридической практики: 17 лет.

Место работы:
• Директор юридической фирмы SGLA (Пекин).
• Арбитр Международного арбитражного суда Бэйхай.
• Заместитель председателя комитета по партийной работе Пекинской коллегии адвокатов.
• Заместитель генерального секретаря комитета по проблемным активам Пекинской коллегии адвокатов.
• Руководитель комитета по налоговому праву Пекинской коллегии адвокатов.

Образование:
• 2000-2005 гг. - Цзилиньский университет, бизнес-факультет, бакалавр.
• 2005-2008 гг. - Цзилиньский университет, юридический факультет, магистр права.
• Участник программы «Цзыцзин» Финансовой школы PBC при Университете Цинхуа.

Специализация:
• Проблемные активы и исполнительное производство.
• Налоговые юридические услуги и налоговые споры.
• Корпоративный комплаенс.
• Сложные коммерческие судебные разбирательства и арбитраж.
• Корпоративное право, недвижимость и строительные проекты.

Профессиональный опыт:
• Вела трансграничные юридические дела с участием Тайваня, Сингапура, Гонконга, США, Японии и Таиланда.
• Предоставляла юридические услуги корпоративным структурам, государственным органам и международным организациям.
• Входит в топ-15 специалистов Китая по работе с проблемными активами и исполнению судебных решений по версии LegalOne.
• Член редакционных коллегий изданий по корпоративному комплаенсу.`,
    },
  },
  {
    id: 118,
    name: { ru: "Сунь На" },
    experience: {
      ru: `Страна: Китай.

Место работы:
• С декабря 2021 г. - Основатель и директор Пекинской юридической фирмы «Чуньхэ».
• Член Комитета по гражданскому праву Пекинской коллегии адвокатов.
• Заместитель председателя Комитета по работе женщин-адвокатов коллегии адвокатов района Дасин.
• Председатель Исследовательского комитета по брачно-семейному праву коллегии адвокатов района Дасин.
• Ранее - внештатный медиатор Центра медиации по гражданским и коммерческим спорам «Дунъу Голянь».

Образование:
• Пекинский университет, юриспруденция.
• Китайский университет политических наук и права, заочная магистратура.

Специализация:
• Корпоративное юридическое консультирование.
• Слияния и разделение компаний, сделки M&A, споры по долям участия.
• Договорные споры, изъятие земель и переселение.
• Брачно-семейные и наследственные дела.
• Внедоговорное возмещение ущерба, иностранные судебные споры и арбитраж.
• Уголовные дела, страхование, трасты и управление капиталом состоятельных лиц.

Квалификация:
• Сертифицированный специалист по слияниям и поглощениям Китая.
• Международный сертифицированный старший специалист по управлению частным капиталом.
• Старший специалист по корпоративному комплаенсу.
• Старший главный специалист по управлению данными.
• Передовой специалист юридической профессии района Дасин, Пекин, 2024 год.

Контакты:
• Телефон: +86 13810782619.
• Эл. почта: lawyersunna@126.com.
• WeChat: sunnynatina.`,
    },
  },
  {
    id: 119,
    name: {
      ru: "Хуан Хуэйин",
      kz: "Хуан Хуэйин",
      en: "Huang Huiying",
      zh: "黄会英",
    },
    experience: {
      ru: `Страна: Китай.

Место работы:
• Партнёр юридической фирмы «Цзянси Айминь» (Jiangxi Aimin Law Firm).
• Член исполнительного профессионального комитета.

Образование:
• Цзянсийский университет финансов и экономики, специальность «Бухгалтерский учёт».

Квалификация:
• 2018 г. - Сдала квалификационный экзамен на юриста.
• Апрель 2020 г. - Получила адвокатское удостоверение № 13601202011180664.

Специализация:
• Крупные гражданские и коммерческие споры, обеспечение исков и исполнительное производство.
• Взыскание проблемных долгов, банкротство, реорганизация и ликвидация предприятий.
• Проверка и приобретение финансовых и проблемных активов, структуры SPV, гарантии и взыскание задолженности.
• Комплексное сопровождение инвестиций и комплаенс с учётом бухгалтерских и налоговых вопросов.

Профессиональный опыт:
• Представляла трастовую компанию в делах на суммы свыше 100 млн юаней; в одном из дел обеспечила возврат 140 млн юаней через медиацию и исполнительное производство.
• Вела дела о взыскании проблемных долгов для China Huarong, China Cinda и региональных компаний по управлению активами.
• Представляла кредиторов при банкротстве Jiangxi Jingpeng Industrial и Nanchang Erqing; разрабатывала планы реорганизации с конвертацией долга в капитал.
• Занималась исполнением решения коммерческого арбитража по делу туристической группы в провинции Цзянси.
• Представляла инвесторов при реорганизации, заключении мировых соглашений и ликвидации в рамках банкротства.`,
      kz: `Елі: Қытай.

Жұмыс орны:
• «Цзянси Айминь» заң фирмасының (Jiangxi Aimin Law Firm) серіктесі.
• Атқарушылық іс жүргізу жөніндегі кәсіби комитеттің мүшесі.

Білімі:
• Цзянси қаржы және экономика университеті, «Бухгалтерлік есеп» мамандығы.

Біліктілігі:
• 2018 ж. - Заңгердің біліктілік емтиханын тапсырған.
• 2020 жылғы сәуір - № 13601202011180664 адвокаттық куәлігін алған.

Мамандануы:
• Ірі азаматтық және коммерциялық даулар, талап қоюды қамтамасыз ету және атқарушылық іс жүргізу.
• Проблемалық берешекті өндіріп алу, кәсіпорындардың банкроттығы, қайта ұйымдастырылуы және таратылуы.
• Қаржылық және проблемалық активтерді тексеру және сатып алу, SPV құрылымдары, кепілдіктер және берешекті өндіріп алу.
• Бухгалтерлік есеп пен салық мәселелерін ескере отырып, инвестицияларды кешенді сүйемелдеу және комплаенс.

Кәсіби тәжірибесі:
• Талап сомасы 100 млн юаньнан асатын істерде траст компаниясының мүддесін қорғаған; бір іс бойынша медиация және атқарушылық іс жүргізу арқылы 140 млн юань қайтаруға қол жеткізген.
• China Huarong, China Cinda және өңірлік активтерді басқару компаниялары үшін проблемалық берешекті өндіріп алу істерін жүргізген.
• Jiangxi Jingpeng Industrial және Nanchang Erqing банкроттығы кезінде кредиторлардың өкілі болған; қарызды капиталға айырбастау арқылы қайта ұйымдастыру жоспарларын әзірлеген.
• Цзянси провинциясындағы туристік топқа қатысты коммерциялық төрелік шешімін орындатумен айналысқан.
• Банкроттық аясындағы қайта ұйымдастыру, бітімгершілік келісімдер және тарату кезінде инвесторлардың мүддесін қорғаған.`,
      en: `Country: China.

Positions:
• Partner, Jiangxi Aimin Law Firm.
• Member of the Executive Professional Committee.

Education:
• Jiangxi University of Finance and Economics, Accounting.

Qualifications:
• 2018 - Passed the legal professional qualification examination.
• April 2020 - Obtained lawyer's practicing certificate No. 13601202011180664.

Practice areas:
• Major civil and commercial disputes, asset preservation and enforcement.
• Non-performing debt recovery, corporate bankruptcy, reorganization and liquidation.
• Due diligence and acquisition of financial and distressed assets, SPV structures, guarantees and debt recovery.
• Integrated investment support and compliance incorporating accounting and taxation.

Professional experience:
• Represented a trust company in claims exceeding RMB 100 million; in one case, helped recover RMB 140 million through mediation and enforcement.
• Handled non-performing debt recovery for China Huarong, China Cinda and regional asset management companies.
• Represented creditors in the bankruptcies of Jiangxi Jingpeng Industrial and Nanchang Erqing; designed restructuring plans involving debt-to-equity swaps.
• Handled enforcement of a commercial arbitration award involving a tourism group in Jiangxi.
• Represented investors in bankruptcy reorganization, composition and liquidation.`,
      zh: `国家：中国。

任职：
• 江西艾民律师事务所合伙人。
• 执行专业委员会委员。

教育背景：
• 江西财经大学，会计学专业。

专业资格：
• 2018年取得法律职业资格。
• 2020年4月取得律师执业证书，证号：13601202011180664。

专业领域：
• 重大民商事争议解决、财产保全及执行。
• 不良债权追偿、企业破产重整与清算。
• 金融及不良资产尽调与受让、SPV架构设计、担保及债务追偿。
• 结合会计与税务知识的投资综合法律服务及合规运营。

执业经历：
• 代理信托公司多起标的额超过亿元的案件；其中一案通过调解及执行成功回款1.4亿元人民币。
• 为中国华融、中国信达及省级资产管理公司办理不良债权追偿案件。
• 在江西晶鹏实业、南昌二轻公司破产案件中代理债权人，设计债转股重整方案。
• 代理江西某旅游集团商事仲裁案件的执行。
• 代表投资人参与破产重整、和解及清算。`,
    },
  },
  {
    id: 120,
    name: {
      ru: "Фан Иньлэ",
      kz: "Фан Иньлэ",
      en: "Fang Yinle",
      zh: "方银乐",
    },
    experience: {
      ru: `Страна: Китай.
Опыт: около тысячи судебных и внесудебных дел.

Место работы:
• Партнёр шанхайского филиала Пекинской юридической фирмы «Инькэ» (Beijing Yingke (Shanghai) Law Firm).
• Наставник-практик Исследовательского центра кредитования Китая Пекинского университета.

Специализация:
• Договорные споры, корпоративные доли и акции, арбитраж, требования и задолженности.
• Строительные споры, крупные сложные экономические и групповые споры.
• Постоянное юридическое консультирование государственных предприятий и публичных компаний.
• Основные регионы практики: Шанхай, Пекин и Шэньчжэнь.

Профессиональный опыт:
• Представлял Guodian Nanjing Automation и её дочерние компании при взыскании просроченной дебиторской задолженности; объём урегулированных требований превысил несколько миллиардов юаней.
• Вёл крупные сложные дела и внесудебные переговоры для Huadian Engineering Group.
• Представлял Shanghai Zhixin Electric Group в договорных спорах и внесудебных переговорах.
• Сопровождал банкротство и ликвидацию Shanghai Yunfeng Pharmaceutical и связанные судебные дела при объёме активов 200 млн юаней.
• В деле о причинении вреда здоровью против спортивной компании из Санья добился благоприятного изменения решения Высшим народным судом провинции Хайнань.`,
      kz: `Елі: Қытай.
Тәжірибесі: мыңға жуық сот және соттан тыс іс.

Жұмыс орны:
• Бейжіңнің «Инькэ» заң фирмасының Шанхай филиалындағы серіктесі (Beijing Yingke (Shanghai) Law Firm).
• Бейжің университетінің Қытай кредитін зерттеу орталығының практикалық тәлімгері.

Мамандануы:
• Шарттық даулар, корпоративтік үлестер мен акциялар, төрелік, талаптар мен берешек.
• Құрылыс даулары, ірі күрделі экономикалық және топтық даулар.
• Мемлекеттік кәсіпорындар мен биржалық компанияларға тұрақты заң кеңесін беру.
• Негізгі қызмет өңірлері: Шанхай, Бейжің және Шэньчжэнь.

Кәсіби тәжірибесі:
• Guodian Nanjing Automation және оның еншілес компанияларының мерзімі өткен дебиторлық берешекті өндіріп алу істерін жүргізген; реттелген талаптардың көлемі бірнеше миллиард юаньнан асқан.
• Huadian Engineering Group үшін ірі күрделі істерді және соттан тыс келіссөздерді жүргізген.
• Shanghai Zhixin Electric Group мүддесін шарттық дауларда және соттан тыс келіссөздерде қорғаған.
• Активтері 200 млн юань болатын Shanghai Yunfeng Pharmaceutical компаниясының банкроттығын, таратылуын және байланысты сот істерін сүйемелдеген.
• Саньядағы спорт компаниясына қарсы денсаулыққа зиян келтіру ісінде Хайнань провинциясының Жоғары халық сотында шешімнің клиент пайдасына өзгертілуіне қол жеткізген.`,
      en: `Country: China.
Experience: nearly one thousand litigation and non-litigation cases.

Positions:
• Partner, Beijing Yingke (Shanghai) Law Firm.
• Practice Mentor, China Credit Research Center, Peking University.

Practice areas:
• Contract disputes, corporate equity, arbitration, claims and debts.
• Construction disputes, major complex economic disputes and group economic disputes.
• Ongoing legal counsel for state-owned enterprises and listed companies.
• Main practice locations: Shanghai, Beijing and Shenzhen.

Professional experience:
• Represented Guodian Nanjing Automation and its subsidiaries in overdue receivables recovery, with successfully resolved claims exceeding several billion RMB.
• Handled major complex cases and non-litigation negotiations for Huadian Engineering Group.
• Represented Shanghai Zhixin Electric Group in contract disputes and non-litigation negotiations.
• Handled bankruptcy liquidation and related litigation for Shanghai Yunfeng Pharmaceutical, involving assets of RMB 200 million.
• Obtained a favorable appellate judgment from the Hainan High People's Court in a personal injury case against a sports company in Sanya.`,
      zh: `国家：中国。
办案经验：近千起诉讼及非诉案件。

任职：
• 北京盈科（上海）律师事务所合伙人。
• 北京大学中国信用研究中心实践导师。

专业领域：
• 合同纠纷、公司股权、仲裁事务、债权债务。
• 建设工程纠纷、重大疑难复杂经济纠纷及群体性经济纠纷。
• 为国有企业及上市公司提供常年法律顾问服务。
• 主要执业地区：上海、北京、深圳。

执业经历：
• 代理国电南京自动化股份有限公司及其子公司处理逾期应收账款，成功处置规模超过数十亿元。
• 为华电科工集团有限公司办理重大疑难案件及非诉谈判。
• 代理上海置信电气集团有限公司处理合同纠纷及非诉谈判。
• 代理上海云峰药业有限公司破产清算及衍生诉讼，资产规模2亿元。
• 在代理当事人诉三亚某体育公司的人身损害案件中，获得海南省高级人民法院改判支持。`,
    },
  },
  {
    id: 121,
    name: {
      ru: "Чжао Хуйин",
      kz: "Чжао Хуйин",
      en: "Zhao Huiying",
      zh: "赵卉颖",
    },
    experience: {
      ru: `Страна: Китай.

Место работы:
• с июня 2026 г. - Руководитель Комитета по зарубежной деятельности Пекинской юридической фирмы «Циншан» (Beijing Qingshang Law Firm).
• Ноябрь 2023 - май 2026 г. - Юрист Пекинской юридической фирмы «Юньцзя» (Beijing Yunjia Law Firm).
• Февраль 2021 - ноябрь 2023 г. - Юрист Пекинской юридической фирмы «Аньтун» (Beijing Antong Law Firm).

Специализация:
• Разрешение гражданских и коммерческих споров.
• Инвестиции и финансирование на рынках капитала, слияния и поглощения (M&A).
• Строительные и договорные споры, неосновательное обогащение, частные займы, аренда и авторское право.

Квалификация:
• Единый государственный квалификационный сертификат юриста.
• Лицензия на адвокатскую практику класса A.
• Сертификат подтверждения компетенций специалиста по корпоративному комплаенсу.
• Квалификационный сертификат специалиста по инвестиционным фондам.

Профессиональный опыт:
• Сопровождала приобретение прав на недра биржевой компании муниципальным государственным инвестиционным фондом провинции Хэбэй.
• Оказывала юридические услуги при M&A биржевой компании в сфере животноводства и содействовала финансированию проекта коммерческой космонавтики.
• Оказывала постоянные юридические услуги филиалу PowerChina в Гуйчжоу.
• Вела споры, связанные с проектом «Молодая мечта» PowerChina в Гуйчжоу стоимостью 300 млн юаней, включая договоры купли-продажи, строительный подряд и неосновательное обогащение, в первой, второй инстанциях и при пересмотре дел.
• Участвовала в спорах о частных займах, строительном подряде, охранных услугах, авторских правах и аренде жилья.`,
      kz: `Елі: Қытай.

Жұмыс орындары:
• 2026 жылғы маусымнан бастап - Бейжіңнің «Циншан» заң фирмасы (Beijing Qingshang Law Firm) шетелдік қызмет комитетінің басшысы.
• 2023 жылғы қараша - 2026 жылғы мамыр - Бейжіңнің «Юньцзя» заң фирмасының (Beijing Yunjia Law Firm) заңгері.
• 2021 жылғы ақпан - 2023 жылғы қараша - Бейжіңнің «Аньтун» заң фирмасының (Beijing Antong Law Firm) заңгері.

Мамандануы:
• Азаматтық және коммерциялық дауларды шешу.
• Капитал нарықтарындағы инвестициялар мен қаржыландыру, бірігу және жұтылу мәмілелері (M&A).
• Құрылыс және шарттық даулар, негізсіз баю, жеке қарыздар, жалдау және авторлық құқық.

Біліктілігі:
• Заңгердің бірыңғай мемлекеттік біліктілік сертификаты.
• А сыныбындағы адвокаттық қызмет лицензиясы.
• Корпоративтік комплаенс маманының құзыреттерін растау сертификаты.
• Инвестициялық қорлар маманының біліктілік сертификаты.

Кәсіби тәжірибесі:
• Хэбэй провинциясының муниципалдық мемлекеттік инвестициялық қорының биржалық компанияға тиесілі жер қойнауын пайдалану құқықтарын сатып алуын сүйемелдеген.
• Мал шаруашылығы саласындағы биржалық компанияның M&A мәмілелеріне заң қызметтерін көрсеткен және коммерциялық ғарыш жобасын қаржыландыруға жәрдемдескен.
• PowerChina компаниясының Гуйчжоу филиалына тұрақты заң қызметтерін көрсеткен.
• PowerChina компаниясының Гуйчжоудағы құны 300 млн юань болатын «Жас арман» жобасына байланысты сатып алу-сату, құрылыс мердігерлігі және негізсіз баю дауларын бірінші, екінші сатыларда және істерді қайта қарау кезінде жүргізген.
• Жеке қарыздар, құрылыс мердігерлігі, күзет қызметтері, авторлық құқық және тұрғын үйді жалдау дауларына қатысқан.`,
      en: `Country: China.

Employment:
• Since June 2026 - Director of the Overseas Business Committee, Beijing Qingshang Law Firm.
• November 2023 - May 2026 - Lawyer, Beijing Yunjia Law Firm.
• February 2021 - November 2023 - Lawyer, Beijing Antong Law Firm.

Practice areas:
• Civil and commercial dispute resolution.
• Capital-market investment and financing, mergers and acquisitions (M&A).
• Construction and contract disputes, unjust enrichment, private lending, leases and copyright.

Qualifications:
• National Unified Legal Professional Qualification Certificate.
• Lawyer's Practice License, Class A.
• Enterprise Compliance Officer Competency Verification Certificate.
• Fund Practitioner Qualification Certificate.

Professional experience:
• Advised a municipal state-owned investment fund in Hebei on acquiring a listed company's mining rights.
• Provided legal services for M&A involving a listed animal-husbandry company and financing support for a commercial aerospace project.
• Provided ongoing legal services to PowerChina Guizhou Branch.
• Handled disputes arising from PowerChina Guizhou's Young Dream project, valued at RMB 300 million, involving sales contracts, construction contracts and unjust enrichment at first instance, appeal and retrial.
• Participated in disputes involving private loans, construction contracts, security services, copyright and residential leases.`,
      zh: `国家：中国。

工作经历：
• 2026年6月至今 - 北京清商律师事务所出海委员会主任。
• 2023年11月—2026年5月 - 北京云嘉律师事务所律师。
• 2021年2月—2023年11月 - 北京市安通律师事务所律师。

专业领域：
• 民商事争议解决。
• 资本市场投融资、并购（M&A）。
• 建设工程及合同纠纷、不当得利、民间借贷、租赁及著作权。

专业资格：
• 国家统一法律职业资格证书。
• 律师执业资格证（A证）。
• 企业合规师人员能力验证证书。
• 基金从业资格证书。

项目经验：
• 为河北省某市级国资基金收购上市公司矿权提供专项法律服务。
• 为某畜牧业上市公司并购提供法律服务，为商业航天项目提供融资支持。
• 为中国电建贵州分公司提供常年法律服务。
• 办理中国电建贵州分公司总造价3亿元的“少年梦”项目及衍生诉讼，涉及买卖合同、建设工程施工合同及不当得利纠纷的一审、二审和再审。
• 参与民间借贷、建设工程施工合同、保安服务合同、著作权及房屋租赁合同纠纷。`,
    },
  },
];

const foreignArbitratorTranslations = {
  101: {
    name: { en: "Wu Chengfang", zh: "吴成芳" },
    experience: {
      en: `Country: China.
Legal practice experience: over 10 years.

Positions:
• Registered arbitrator of the Fuzhou Arbitration Commission.
• Dean of the Financial Arbitration Institute of the Fuzhou Arbitration Commission.
• 2008-present - Managing Partner and Director, Beijing Zunping Law Firm.
• 2005-2008 - Legal Counsel, Beijing Wanxing Construction Group.
• 2001-2003 - Inspection Team, Jiangxi Bureau of Quality and Technical Supervision.

Education:
• 1997-2001 - Jiangxi Institute of Education, Bachelor's degree in Chinese Language and Literature.

Practice areas:
• Civil and commercial litigation.
• Criminal litigation.
• Litigation preservation and enforcement.
• Corporate disputes and non-litigation legal matters.

Qualifications:
• Licensed practicing attorney.
• Handled more than one hundred litigation cases of various types.`,
      zh: `国家：中国。
律师执业经验：十年以上。

任职：
• 抚州仲裁委员会在册仲裁员。
• 抚州仲裁委员会金融仲裁院院长。
• 2008年至今 - 北京尊平律师事务所主任合伙人。
• 2005-2008年 - 北京万兴建筑集团法律顾问。
• 2001-2003年 - 江西质监局稽查队。

教育背景：
• 1997-2001年 - 江西省教育学院，中文专业，本科。

专业领域：
• 民商事诉讼。
• 刑事诉讼。
• 诉讼保全与执行。
• 企业民商事、刑事诉讼及非诉法律事务。

资格：
• 律师执业证。
• 代理过百余件各类诉讼案件。`,
    },
  },
  102: {
    name: { en: "Chen Xumei", zh: "陈旭梅" },
    experience: {
      en: `Country: China.
Legal practice experience: 11 years.

Positions:
• Registered arbitrator of the Fuzhou Arbitration Commission.
• Arbitrator of Fuzhou Financial Arbitration Institute, Director of the Capital Markets Professional Committee.
• Director of the Financial Business Law Research Committee, Beijing Daxing District Lawyers Association.
• Deputy Director of the Corporate Law Research Committee, Beijing Daxing District Lawyers Association.
• Member of the Disciplinary Committee, Beijing Daxing District Lawyers Association.

Education:
• Shandong University of Finance and Economics, Bachelor's degree in Management.
• China University of Political Science and Law, postgraduate studies in Civil Law.

Practice areas:
• Corporate management, risk control and compliance systems.
• Capital markets, equity strategy and cross-border investment structures.
• Private fund establishment compliance and special listing routes.
• Commercial dispute prevention through pre-arbitration mediation.

Qualifications:
• Fund practitioner qualification.
• Securities practitioner qualification.
• CET-6 and National Computer Rank Examination Level 2.`,
      zh: `国家：中国。
律师执业经验：11年。

任职：
• 抚州仲裁委员会在册仲裁员。
• 抚仲金融仲裁院仲裁员，资本市场事务专业委员会主任。
• 北京市大兴区律师协会金融业务法律研究会主任。
• 北京市大兴区律师协会公司法律研究会副主任。
• 北京市大兴区律师协会惩戒委委员。

教育背景：
• 山东财经大学，管理学学士。
• 中国政法大学在职研究生，民法专业。

专业领域：
• 企业经营管理、风险控制与合规体系建设。
• 资本市场、股权战略、跨境投资架构。
• 私募基金设立合规、特殊上市路径。
• 仲裁调解前置的商事争议预防。

资格：
• 基金从业资格。
• 证券从业资格。
• 英语六级、计算机二级。`,
    },
  },
  103: {
    name: { en: "Liu Disi", zh: "刘迪思" },
    experience: {
      en: `Country: China.

Positions:
• 2024-present - Co-founder and Deputy Director, Beijing Bato Law Firm.
• Since 2014 - Beijing Bohen Law Firm, firm management and administration.
• Member of the Marriage and Family Law Research Committee, Beijing Daxing District Lawyers Association.
• Member of the Corporate Law Research Committee, Beijing Daxing District Lawyers Association.

Education:
• Beijing Wuzi University, Finance (Securities and Futures).
• China University of Political Science and Law, part-time master's program.

Practice areas:
• Corporate legal advisory, M&A, equity disputes and contract disputes.
• Marriage and family matters, wills, inheritance and tort damages.
• Criminal cases including bribery, fraud, illegal public deposits and economic crimes.
• Corporate listing, equity design, investment and financing, labor and HR management.

Qualifications:
• Extensive law firm management experience.
• Experience in compliance review and risk control.`,
      zh: `国家：中国。

任职：
• 2024年至今 - 北京霸图律师事务所创始人、副主任。
• 2014年起 - 北京博审律师事务所，负责律所管理和行政工作。
• 北京市大兴区律师协会婚姻家庭法律研究会委员。
• 北京市大兴区律师协会公司法律研究会委员。

教育背景：
• 北京物资学院，金融（证券、期货）专业。
• 中国政法大学在职硕士研究生。

专业领域：
• 企业法律顾问、并购交易、股权纠纷、合同纠纷。
• 婚姻家庭、遗嘱继承、侵权损害赔偿。
• 行贿受贿、诈骗、非法吸收公众存款等刑事案件。
• 企业上市、股权设计、投资融资、劳动人事管理。

资格：
• 多年律所管理经验。
• 公司合规审查和风险把控经验。`,
    },
  },
  104: {
    name: { en: "Sun Haibo", zh: "孙海波" },
    experience: {
      en: `Country: China.
Legal practice experience: 16 years.

Positions:
• Since June 2025 - Director, Beijing Weili Law Firm.
• 2020-2025 - Director, Beijing Guolei Law Firm.
• 2012-2020 - Full-time lawyer, Beijing Daming Law Firm.
• Registered arbitrator of Fuzhou Arbitration Commission.
• Vice President of the Financial Arbitration Court of Fuzhou Arbitration Commission.
• Arbitrator of Ganzhou New Area International Arbitration Court and Yulin Arbitration Commission.

Education:
• 2010-2016 - Peking University, Bachelor of Laws.
• 2013-2015 - North China University of Technology, Master of Laws.

Practice areas:
• Domestic trade and construction engineering.
• Accounts receivable management and compulsory enforcement.
• Commercial arbitration, mediation, civil and commercial dispute representation.
• Corporate compliance, contract management, equity design and labor compliance.

Qualifications:
• Passed the National Unified Legal Professional Qualification Examination in 2010.
• Obtained lawyer's practicing certificate in 2015.
• Certified corporate compliance officer.
• Basic English reading and writing capability.`,
      zh: `国家：中国。
法律执业年限：16年。

任职：
• 2025年6月至今 - 北京纬理律师事务所主任。
• 2020-2025年 - 北京国雷律师事务所主任。
• 2012-2020年 - 北京大铭律师事务所专职律师。
• 抚州仲裁委员会在册仲裁员。
• 抚州仲裁委员会金融仲裁院副院长。
• 赣州新区国际仲裁院仲裁员、玉林仲裁委员会仲裁员。

教育背景：
• 2010-2016年 - 北京大学，法学学士。
• 2013-2015年 - 北方工业大学，法律硕士。

专业领域：
• 国内贸易与建设工程。
• 企业应收账款管理与强制执行。
• 商事仲裁、调解、民商事纠纷代理。
• 企业合规、合同管理、股权设计、劳动用工合规。

资格：
• 2010年通过国家统一法律职业资格考试。
• 2015年取得律师执业证。
• 企业合规师。
• 具备基础英语读写能力。`,
    },
  },
  105: {
    name: { en: "Zeng Shanen", zh: "曾善恩" },
    experience: {
      en: `Country: China.

Positions:
• 2014-present - Attorney-at-law, Guangdong South-Freedom Law Firm.
• 2018-present - Arbitrator, Beihai Arbitration Commission / Beihai International Arbitration Court.

Education:
• 2004-2010 - China Central Radio and TV University, Bachelor of Laws.
• 2001-2004 - Guangzhou Radio and Television University, Law.
• 1995-1999 - Shanghai Harbor School, Shipping Finance.

Practice areas:
• Legal consulting services.
• Litigation practice and arbitration.

Contacts:
• Phone: +86 13609094569.
• Email: 88318@163.com.`,
      zh: `国家：中国。

任职：
• 2014年至今 - 广东南方福瑞德律师事务所，专职律师。
• 2018年至今 - 北海仲裁委员会北海国际仲裁院仲裁员。

教育背景：
• 2004-2010年 - 中央广播电视大学，本科，法学。
• 2001-2004年 - 广州市广播电视大学，大专，法学。
• 1995-1999年 - 上海港湾学校，中专，水运财务。

专业领域：
• 法律咨询服务。
• 诉讼实务与仲裁。

联系方式：
• 手机：+86 13609094569。
• 邮箱：88318@163.com。`,
    },
  },
  106: {
    name: { en: "Hongjun Hu", zh: "胡红军" },
    experience: {
      en: `Country: China.

Positions:
• 2024-present - Chairman, International Economic and Trade Arbitration Court of Fuzhou Arbitration Commission.
• 2024-present - Arbitrator, World Trade Center Macau Arbitration Center.
• 2022-present - Arbitrator, Nanping International Arbitration Court.
• 2018-present - Arbitrator, Beihai International Arbitration Court.
• 2016-present - Arbitrator, Zhanjiang Arbitration Commission.
• 1992-2004 - Assistant judge and enforcement officer, Guangzhou Intermediate People's Court.

Education:
• China University of Political Science and Law, Economic Law.
• Nanjing University of Science and Technology, Human Resource Management.
• Peking University, Law.

Practice areas:
• Arbitration, economic and trade disputes.
• Enforcement and commercial dispute resolution.`,
      zh: `国家：中国。

任职：
• 2024年至今 - 抚州仲裁委员会国际经济贸易仲裁院院长。
• 2024年至今 - 澳门世界贸易中心仲裁中心仲裁员。
• 2022年至今 - 南平国际仲裁院仲裁员。
• 2018年至今 - 北海国际仲裁院仲裁员。
• 2016年至今 - 湛江仲裁委员会仲裁员。
• 1992-2004年 - 广州市中级人民法院助理审判员、执行员。

教育背景：
• 中国政法大学，经济法。
• 南京理工大学，人力资源管理。
• 北京大学，法学。

专业领域：
• 仲裁、经济贸易争议。
• 执行及商事争议解决。`,
    },
  },
  107: {
    name: { en: "Sun Qian", zh: "孙乾" },
    experience: {
      en: `Country: China.

Positions:
• Practicing lawyer, Beijing Huanying Law Firm.
• Many years of experience in the financial sector.

Education:
• Central University of Finance and Economics.

Practice areas:
• Civil and criminal law.
• Corporate disputes, equity disputes and major commercial contracts.
• Defense of companies and senior executives in economic and duty-related criminal cases.
• M&A, investment projects, debt recovery and construction contracts.

Professional experience:
• Participated in major criminal cases involving illegal fundraising and illegal business operations.
• Handled civil and commercial cases involving amounts from millions to tens of billions of yuan.`,
      zh: `国家：中国。

任职：
• 北京寰瀛律师事务所执业律师。
• 具有多年金融行业工作经验。

教育背景：
• 中央财经大学。

专业领域：
• 民事与刑事法律。
• 公司股权纠纷、重大商事合同。
• 企业和高管经济犯罪、职务犯罪案件辩护。
• 并购、投资项目、债权追收、建设工程合同。

专业经验：
• 参与多起非法集资、非法经营等重大刑事案件。
• 处理标的从数百万元至数百亿元的民商事案件。`,
    },
  },
  108: {
    name: { en: "Song Jinyu", zh: "宋金玉" },
    experience: {
      en: `Country: China.

Positions:
• 2015-present - Senior Partner and Head of International Business Department, Beijing Jingping Law Firm.
• 2012-2015 - Partner Attorney, Beijing Shengyun Law Firm.
• 2008-2011 - Attorney, Beijing Tianrui Law Firm.

Education:
• Linyi Normal University, Bachelor of Arts in English.
• University of International Business and Economics, Juris Master.
• Chinese Academy of Social Sciences, Master of Economics in Finance.
• Renmin University, EMBA.

Practice areas:
• Legal services for domestic and international enterprises.
• Administrative reconsideration and litigation, civil, commercial and criminal cases.
• Foreign-related legal services and cooperation with chambers of commerce and foreign law firms.
• Law firm management and strategy.

Qualifications:
• Legal practice qualification certificate.
• TEM-8 certificate.
• Senior corporate compliance, equity structure and labor relations certificates.`,
      zh: `国家：中国。

任职：
• 2015年至今 - 北京京平律师事务所高级合伙人及涉外业务部负责人。
• 2012-2015年 - 北京圣运律师事务所合伙人律师。
• 2008-2011年 - 北京天睿律师事务所律师。

教育背景：
• 临沂师范学院，英语本科。
• 对外经济贸易大学，法律硕士。
• 中国社会科学院，经济学硕士（金融）。
• 中国人民大学，工商管理硕士（EMBA）。

专业领域：
• 为国内外企业提供法律服务。
• 行政复议、行政诉讼、民商事和刑事案件。
• 涉外法律服务、商会及国外律所合作。
• 律所管理与战略研究。

资格：
• 律师执业资格证书。
• 英语专业八级证书。
• 企业合规、股权架构及劳动关系相关高级证书。`,
    },
  },
  109: {
    name: { en: "Lu Bin", zh: "卢宾" },
    experience: {
      en: `Country: China.
Experience in enforcement and bankruptcy practice: over 10 years.

Positions:
• 2018-present - Founder and Director, Beijing Jiahuan Law Firm.
• 2014-2018 - Beijing Songtao Law Firm.
• 2010-2014 - Beijing Qingtian Law Firm.

Practice areas:
• Revitalization and recovery of non-performing assets.
• Enforcement of terminated cases.
• Bankruptcy and non-performing asset recovery.
• Cross-border compulsory enforcement.

Industry positions:
• Member of Beijing Bar Association.
• Supervisor of Shunyi District Bar Association.
• Supervisor of Beijing Bar Association.

Qualifications:
• Legal Professional Qualification Grade A.
• Languages: Russian, Chinese.`,
      zh: `国家：中国。
强制执行及破产业务经验：十年以上。

任职：
• 2018年至今 - 北京嘉桓律师事务所创始人、主任。
• 2014-2018年 - 北京松涛律师事务所。
• 2010-2014年 - 北京青天律师事务所。

专业领域：
• 不良资产盘活与清收。
• 终本案件执行。
• 破产及不良资产清收。
• 跨境强制执行。

行业任职：
• 北京市律师协会会员。
• 顺义区律师协会监事。
• 北京市律师协会监事。

资格：
• 法律职业资格A证。
• 语言：俄语、中文。`,
    },
  },
  110: {
    name: { en: "Du Limin", zh: "杜丽民" },
    experience: {
      en: `Country: China.
Total legal experience: over 17 years.
Attorney practice experience: over 6 years.

Positions:
• 2020-present - Senior Partner and Team Leader, Beijing Jinheng Law Firm (Guangzhou).
• 2017-2020 - Hunan Kuanzhen Law Firm, trainee attorney and practicing attorney.
• 2009-2017 - Compliance risk department in the banking sector, Xinjiang.

Education:
• Xinjiang University of Finance and Economics, Bachelor of Laws.
• Xinjiang University, Master in Legal Theory.

Practice areas:
• Construction law and commercial disputes.
• Construction contract disputes, payment arrears, quality and delay claims.
• Enforcement and recovery of funds.
• Mediation and civil-commercial dispute resolution.

Qualifications:
• Grade A Legal Professional Qualification Certificate.
• Lawyer Practicing License.
• CET-6 Certificate.
• Certified International Financial Planner (CIFP).`,
      zh: `国家：中国。
法律行业总经验：17年以上。
律师执业经验：6年以上。

任职：
• 2020年至今 - 北京金恒（广州）律师事务所高级合伙人、团队负责人。
• 2017-2020年 - 湖南旷真律师事务所，实习律师、执业律师。
• 2009-2017年 - 新疆银行系统合规风险部门。

教育背景：
• 新疆财经大学，法学本科。
• 新疆大学，法学理论硕士。

专业领域：
• 建设工程法律与商事争议。
• 建设工程合同、工程款、质量及工期争议。
• 执行及款项回收。
• 调解与民商事争议解决。

资格：
• 法律职业资格证书（A类）。
• 律师执业证。
• 英语CET-6证书。
• 注册国际金融理财师（CIFP）。`,
    },
  },
  111: {
    name: { en: "Zhou Weijia", zh: "周卫家" },
    experience: {
      en: `Country: China.
Court trial experience: 16 years.

Positions:
• 2022-present - Partner Lawyer, Tianjin Dongfang Law Firm.
• 2006-2022 - Xinjiang Production and Construction Corps Court System: clerk, judge, court president and civil court president.

Education:
• Dalian Maritime University, Master's degree in Law.
• Xinjiang Normal University, Bachelor's degree in Law.

Practice areas:
• Civil and commercial economic disputes.
• Enterprise legal advisory services.
• Insurance claim disputes, corporate compliance and risk control.
• International arbitration and cross-border commercial disputes.

Qualifications:
• PRC Lawyer's Practice Certificate.
• National Legal Professional Qualification Certificate.
• Russian communication skills for Central Asia and Russia-related legal matters.`,
      zh: `国家：中国。
法院审判实务经验：16年。

任职：
• 2022年至今 - 天津东方律师事务所合伙人律师。
• 2006-2022年 - 新疆生产建设兵团法院系统，书记员、审判员、法庭庭长、民庭庭长。

教育背景：
• 大连海事大学，法学硕士。
• 新疆师范大学，法学学士。

专业领域：
• 民商事经济纠纷。
• 企业法律顾问服务。
• 保险理赔争议、企业合规风控。
• 国际仲裁与跨境商事争议。

资格：
• 中华人民共和国律师执业证。
• 国家法律职业资格证书。
• 具备俄语沟通能力，适应涉中亚、涉俄法律事务。`,
    },
  },
  112: {
    name: { en: "Li Yan", zh: "李艳" },
    experience: {
      en: `Country: China.
Total legal experience: 10 years.
Attorney practice experience: over 6 years.

Positions:
• 2022-present - Senior Partner, Firm Director and Team Leader, Beijing Jinheng Law Firm.
• 2019-2022 - Practicing Attorney, Beijing Celue Law Firm.
• 2017-2019 - Beijing Lanpeng Law Firm.
• 2016-2017 - Beijing Jingshi Law Firm.

Education:
• Shenyang Normal University, English.
• University of International Relations, Master in Law.

Practice areas:
• Construction contract disputes.
• Commercial contract disputes, debt recovery and lease disputes.
• Commercial arbitration and compulsory enforcement.
• Infrastructure and construction projects, mediation and arbitration procedure.

Qualifications:
• Grade A Legal Professional Qualification Certificate.
• Lawyer Practicing License.
• TEM-8 English Certificate.
• Mandarin Level 2-A Certificate.`,
      zh: `国家：中国。
法律行业总经验：10年。
律师执业经验：6年以上。

任职：
• 2022年至今 - 北京金恒律师事务所高级合伙人、律所负责人、团队负责人。
• 2019-2022年 - 北京策略律师事务所执业律师。
• 2017-2019年 - 北京蓝鹏律师事务所。
• 2016-2017年 - 北京京师律师事务所。

教育背景：
• 沈阳师范大学，英语专业。
• 国际关系学院，法律硕士。

专业领域：
• 建设工程合同纠纷。
• 商事合同纠纷、债务追收、租赁纠纷。
• 商事仲裁与强制执行。
• 基础设施及建设项目、调解和仲裁程序。

资格：
• 法律职业资格证书（A类）。
• 律师执业证。
• 英语专业八级证书。
• 普通话二级甲等证书。`,
    },
  },
  113: {
    name: { en: "Yang Ling", zh: "杨玲" },
    experience: {
      en: `Country: China.
Total legal experience: 16 years.
Attorney practice experience: over 5 years.

Positions:
• 2020-present - Founding Partner of Beijing Jinheng Law Firm and Head of Beijing Jinheng (Tianjin) Branch.
• 2017-2020 - Hunan Kuanzhen Law Firm (Urumqi): client attorney, litigation director and client department director.
• 2010-2017 - Court of the Xinjiang Production and Construction Corps: court clerk and assistant judge.

Education:
• Xinjiang University, Bachelor of Laws.

Practice areas:
• Construction disputes, bidding, subcontracting and construction contracts.
• Commercial contract disputes, sale and purchase, lease, loans, guarantees and partnerships.
• Debt recovery, enforcement and commercial arbitration.
• Mediation, arbitration hearings and post-award enforcement.

Professional experience:
• The team handles more than 200 commercial cases annually.
• More than 50 cases annually are heard by arbitration commissions in Beijing, Tianjin, Shanghai, Wuhan and other cities.
• Total recovered funds for clients exceed RMB 2 billion.`,
      zh: `国家：中国。
法律行业总经验：16年。
律师执业经验：5年以上。

任职：
• 2020年至今 - 北京金恒律师事务所创始合伙人、北京金恒（天津）分所负责人。
• 2017-2020年 - 湖南旷真（乌鲁木齐）律师事务所，客户律师、诉讼负责人、客户部负责人。
• 2010-2017年 - 新疆生产建设兵团相关法院，书记员、法官助理。

教育背景：
• 新疆大学，法学本科。

专业领域：
• 建设工程争议、招投标、分包、建设工程合同。
• 商事合同、买卖、租赁、借款、担保、合伙等争议。
• 债务追收、执行与商事仲裁。
• 调解、仲裁庭审及裁决后执行。

专业经验：
• 团队每年处理200余件商事案件。
• 每年50余件案件进入北京、天津、上海、武汉等仲裁委员会。
• 为客户回款总额超过20亿元人民币。`,
    },
  },
  114: {
    name: { en: "Zhang Chao", zh: "张超" },
    experience: {
      en: `Country: China.
Judicial experience: 5 years.
Experience in judicial and investigative authorities: over 10 years.

Positions:
• 2020-present - Managing Partner, Beijing Jinheng Law Firm, construction law and commercial disputes.
• 2014-2020 - Hunan Kuanzhen Law Firm: trainee attorney, practicing attorney and partner.
• 2013-2020 - Prosecutor, People's Procuratorate of Xinjiang Uygur Autonomous Region.
• 2008-2013 - Judge, Shayibake District People's Court, Urumqi.

Education:
• Northwest University of Political Science and Law, Bachelor of Laws.
• Xinjiang University, Master in Law.

Practice areas:
• Civil and commercial law, contract law, property law and security law.
• Corporate law, bankruptcy and construction contracts.
• Investigation and defense in duty-related crime cases.
• Commercial arbitration and enforcement.

Professional experience:
• Handled more than 1,800 civil and commercial cases as a judge.
• Participated in major corruption investigations.
• Represented clients in construction and commercial arbitration cases.`,
      zh: `国家：中国。
审判经验：5年。
司法及侦查机关工作经验：10年以上。

任职：
• 2020年至今 - 北京金恒律师事务所管理合伙人，建设工程与商事争议方向。
• 2014-2020年 - 湖南旷真律师事务所，实习律师、执业律师、合伙人。
• 2013-2020年 - 新疆维吾尔自治区人民检察院，检察官。
• 2008-2013年 - 乌鲁木齐市沙依巴克区人民法院法官。

教育背景：
• 西北政法大学，法学本科。
• 新疆大学，法学硕士。

专业领域：
• 民商法、合同法、物权法、担保法。
• 公司法、破产、建设工程合同。
• 职务犯罪案件调查与辩护。
• 商事仲裁与强制执行。

专业经验：
• 法院工作期间审理1800余件民商事案件。
• 参与多起重大腐败案件调查。
• 代理建设工程及商事仲裁案件。`,
    },
  },
  115: {
    name: { en: "Yin Xiangyang", zh: "殷湘洋" },
    experience: {
      en: `Country: China.

Positions:
• 2020-present - Beijing Zunping Law Firm.
• 2014-2020 - Beijing Handa Law Firm.
• 2008-2014 - Court work.

Education:
• China University of Political Science and Law, Master's degree.

Practice areas:
• Civil and commercial litigation and arbitration.
• Corporate matters and contract disputes.
• Private lending, marriage, family and succession matters.
• Tort compensation and labor disputes.

Qualifications:
• CET-6 English certificate.
• Strong knowledge of commercial laws and regulations.
• Published articles in Beijing Judges and Beijing Trial.
• The paper on debt assumption won a national second prize at the 26th National Court Academic Symposium.`,
      zh: `国家：中国。

任职：
• 2020年至今 - 北京尊平律师事务所。
• 2014-2020年 - 北京市汉达律师事务所。
• 2008-2014年 - 法院工作。

教育背景：
• 中国政法大学，研究生硕士。

专业领域：
• 民商事诉讼与仲裁。
• 公司事务、合同纠纷。
• 民间借贷、婚姻家事、继承。
• 侵权赔偿、劳动争议。

资格：
• 英语六级。
• 精通商事法律法规。
• 在《北京法官》《北京审判》发表多篇文章。
• 关于债务加入的论文获全国法院第二十六届学术研讨会全国二等奖。`,
    },
  },
  116: {
    name: { en: "Chunyan Ding", zh: "丁春燕" },
    experience: {
      en: `Country: China.

Positions:
• June 2025-present - Senior Partner, SGLA (Beijing) Law Firm.
• 2021-2025 - Director of Commercial Department, Beijing Hezhidun Law Firm.
• 2019-2021 - Postdoctoral Fellow, Chinese Academy of Agricultural Sciences.
• 2018-2019 - Teacher, Law Department of Guangdong University of Finance.
• 2017-2018 - Investment Director, Country Garden Holdings.

Education:
• Wuhan University, Doctor of Law.
• Macquarie University, PhD in Accounting and Corporate Management.

Practice areas:
• Foreign-related compliance.
• Commercial litigation and arbitration.
• Investment acquisitions and mergers.
• Legal compliance services for Chinese enterprises' overseas business.

Qualifications:
• Member of the foreign-related lawyer talent pool of the Beijing Bar Association.
• Member of the Central Legal Committee of the Jiusan Society.
• Member of the Legal Committee of the Beijing European and American Alumni Association.
• Member of SGLA national committees on enterprise compliance and construction engineering.
• Author and co-author of legal academic and practical publications.`,
      zh: `国家：中国。

任职：
• 2025年6月至今 - 上海中联（北京）律师事务所高级合伙人。
• 2021-2025年 - 北京和之盾律师事务所公司商事部主任。
• 2019-2021年 - 中国农业科学院博士后。
• 2018-2019年 - 广东金融学院法律系教师。
• 2017-2018年 - 碧桂园集团投资总监。

教育背景：
• 武汉大学，法学博士。
• 麦考瑞大学，会计与公司管理专业博士。

专业领域：
• 涉外合规。
• 商事诉讼与仲裁。
• 投资收并购。
• 中国企业涉外业务法律合规服务。

资格：
• 北京市律师协会涉外律师人才库律师。
• 九三学社中央法律专委会委员。
• 北京市欧美同学会法律专委会委员。
• 中联全国企业合规专业委员会及全国建设工程委员会委员。
• 多部法律著作作者及合著者。`,
    },
  },
  117: {
    name: { en: "Sun Xiaoying", zh: "孙晓颖" },
    experience: {
      en: `Country: China.
Legal practice experience: 17 years.

Positions:
• Director of SGLA Law Firm (Beijing).
• Arbitrator, Beihai International Arbitration Court.
• Deputy Director, Party Building Committee of Beijing Lawyers Association.
• Deputy Secretary-General, Non-performing Assets Committee of Beijing Lawyers Association.
• Group Leader, Tax and Legal Professional Committee of Beijing Lawyers Association.

Education:
• 2000-2005 - Jilin University Business School, Bachelor's degree.
• 2005-2008 - Jilin University Law School, Master of Law.
• Participant of the Zijing Program, Tsinghua PBC School of Finance.

Practice areas:
• Non-performing asset disposal and enforcement.
• Tax-related legal services and tax disputes.
• Corporate compliance.
• High-end commercial litigation and arbitration.
• Corporate law, real estate and construction engineering matters.

Professional experience:
• Handled cross-border legal matters involving Taiwan, Singapore, Hong Kong, the United States, Japan and Thailand.
• Provided legal services to corporate entities, government authorities and international institutions.
• Ranked among China's top 15 lawyers for non-performing asset disposal and enforcement by LegalOne.
• Editorial contributor to corporate compliance publications.`,
      zh: `国家：中国。
法律执业年限：17年。

任职：
• 上海中联（北京）律师事务所主任。
• 北海国际仲裁院仲裁员。
• 北京市律师协会党建委员会副主任。
• 北京市律师协会不良资产委员会副秘书长。
• 北京市律协财税法律专业委员会组长。

教育背景：
• 2000-2005年 - 吉林大学商学院，本科。
• 2005-2008年 - 吉林大学法学院，法学硕士。
• 清华五道口紫荆计划学员。

专业领域：
• 不良资产处置与执行。
• 税务法律服务及税务争议。
• 企业合规。
• 高端商事诉讼与仲裁。
• 公司、房地产开发及建设工程法律事务。

专业经验：
• 承办涉及台湾、新加坡、香港、美国、日本、泰国等涉外法律事务。
• 为企业、政府机关及机构提供法律服务。
• LegalOne不良资产处置与执行中国区十五强。
• 参与多部企业合规实务著作编写。`,
    },
  },
  118: {
    name: { en: "Sun Na", zh: "孙娜" },
    experience: {
      en: `Country: China.

Positions:
• Since December 2021 - Founder and Director, Beijing Chunhe Law Firm.
• Member, Civil Law Professional Committee of the Beijing Bar Association.
• Deputy Director, Women Lawyers' Working Committee of the Daxing District Bar Association.
• Director, Marriage and Family Law Research Committee of the Daxing District Bar Association.
• Former part-time mediator at Dongwu Guolian Civil and Commercial Mediation Center.

Education:
• Peking University, Law.
• China University of Political Science and Law, on-the-job master's program.

Practice areas:
• Corporate legal advisory.
• Mergers, divisions, M&A transactions and equity disputes.
• Contract disputes, land expropriation and relocation.
• Marriage, family, wills and succession matters.
• Tort damages, foreign-related litigation and arbitration.
• Criminal cases, insurance, trusts and wealth management for high-net-worth individuals.

Qualifications:
• China M&A Dealer.
• International Certified Senior Private Wealth Manager.
• Senior Corporate Compliance Officer.
• Senior Chief Data Officer.
• Advanced Individual of the Legal Profession in Daxing District, Beijing, 2024.

Contacts:
• Phone: +86 13810782619.
• Email: lawyersunna@126.com.
• WeChat: sunnynatina.`,
      zh: `国家：中国。

任职：
• 2021年12月至今 - 北京春禾律师事务所主任、创始人。
• 北京市律师协会民法专业委员会委员。
• 北京市大兴区律师协会女律师工作委员会副主任。
• 北京市大兴区律师协会婚姻家庭法律研究会主任。
• 曾任东吴国联民商事调解中心兼职调解员。

教育背景：
• 北京大学，法学专业。
• 中国政法大学，在职硕士研究生。

专业领域：
• 企业法律顾问。
• 公司合并与分立、并购交易、股权纠纷。
• 合同纠纷、征地拆迁。
• 婚姻家庭、遗嘱继承。
• 侵权损害赔偿、涉外诉讼与仲裁。
• 刑事案件、保险与信托、高净值人士财富传承与管理。

资格：
• 中国并购交易师。
• 国际注册高级私人财富管理师。
• 高级企业合规师。
• 高级首席数据官。
• 2024年度北京市大兴区律师行业先进个人。

联系方式：
• 电话：+86 13810782619。
• 邮箱：lawyersunna@126.com。
• 微信号：sunnynatina。`,
    },
  },
};

const localizedForeignArbitratorsData = foreignArbitratorsData.map(
  (arbitrator) => {
    const translation = foreignArbitratorTranslations[arbitrator.id];

    if (!translation) {
      return arbitrator;
    }

    return {
      ...arbitrator,
      name: {
        ...arbitrator.name,
        ...translation.name,
      },
      experience: {
        ...arbitrator.experience,
        ...translation.experience,
      },
    };
  }
);

const ReestrPage = () => {
  const { t, currentLanguage } = useLanguage();
  const lang = currentLanguage;
  const [activeRegistry, setActiveRegistry] = useState("local");

  const registries = [
    {
      key: "local",
      label: t("reestr_local_tab"),
      count: localArbitratorsData.length,
      items: localArbitratorsData,
    },
    {
      key: "foreign",
      label: t("reestr_foreign_tab"),
      count: localizedForeignArbitratorsData.length,
      items: localizedForeignArbitratorsData,
    },
  ];

  const activeRegistryData = registries.find(
    (registry) => registry.key === activeRegistry
  );

  return (
    <Layout>
      <div className="container mx-auto px-4 py-32">
        <h1 className="text-3xl font-bold mb-6 text-center text-blue-800">
          {t("reestr_title")}
        </h1>
        <p className="text-lg text-gray-600 mb-8 text-center max-w-3xl mx-auto">
          {t("reestr_page_desc")}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 mb-8">
          {registries.map((registry) => {
            const isActive = activeRegistry === registry.key;

            return (
              <button
                key={registry.key}
                onClick={() => setActiveRegistry(registry.key)}
                className={`px-5 py-3 rounded-lg border text-sm sm:text-base font-semibold transition-colors ${
                  isActive
                    ? "bg-blue-900 border-blue-900 text-white shadow-md"
                    : "bg-white border-blue-100 text-blue-800 hover:bg-blue-50"
                }`}
              >
                {registry.label}
                <span
                  className={`ml-2 text-xs ${
                    isActive ? "text-blue-100" : "text-gray-500"
                  }`}
                >
                  {registry.count}
                </span>
              </button>
            );
          })}
        </div>

        <div>
          {activeRegistryData.items.length > 0 ? (
            activeRegistryData.items.map((arbitrator) => (
              <ArbitratorCard
                key={arbitrator.id}
                arbitrator={arbitrator}
                lang={lang}
              />
            ))
          ) : (
            <div className="border border-dashed border-blue-200 rounded-lg bg-blue-50 p-8 text-center">
              <h2 className="text-xl font-semibold text-blue-900 mb-2">
                {t("reestr_empty_title")}
              </h2>
              <p className="text-gray-600">
                {t("reestr_empty_desc")}
              </p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ReestrPage;
